import {Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";

import React, {useContext, useEffect, useRef, useState} from "react";
import {
  cancelClientReservation,
  cancelCustomerMembership,
  checkOutClientReservation,
  deleteClientNote,
  deleteCustomer,
  deleteCustomerBilling,
  deleteCustomerFamily,
  deleteCustomerInvoice,
  deleteCustomerInvoiceGroup,
  deleteCustomerMembership,
  getClientMemberPerks,
  getClientNotes,
  getClientWaiver,
  getCustomer,
  getCustomerInvoice,
  getReservations,
  getVisits,
  mergeCustomerInvoices,
  noShowClientReservation,
  pauseEmail,
  previewClientWaiver,
  recordCustomerVisit,
  removeCartItem,
  removeClientPerk,
  removeClientTag,
  restoreCustomer,
  saveClientAccount,
  saveClientAccountStartDate,
  saveClientBilling,
  saveClientNote,
  saveClientReservation,
  saveClientTag,
  saveCustomer,
  saveMoveEventReservation,
  savePrimaryClientBilling,
  sendInvoiceReminderMessage,
  unpauseEmail
} from "../common/api/WebApi";
import {
  colorize,
  customerInitials,
  customerQrCode,
  displayPhone,
  formatAge,
  formatCurrency,
  formatDate,
  formatDateTime,
  getDateNoTz
} from "../common/Utils";
import Badge from '@mui/material/Badge';
import {
  ButtonGroup,
  Card,
  CardContent,
  Chip,
  Fab,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Skeleton
} from "@mui/material";
import ManageClientModal from "./ManageClientModal";
import QRCode from "react-qr-code";
import ManageFamilyMemberModal from "./ManageFamilyMemberModal";
import Confirm from "../common/Confirm";
import ManageClientBillingModal from "./ManageClientBillingModal";
import ClientNoteModal from "./ClientNoteModal";
import Meta from "../common/Meta";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Divider from "@mui/material/Divider";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import Footer from "../Footer";
import NotificationItem from "../Items/NotificationItem";
import Menu from "@mui/material/Menu";
import {CONSTANTS} from "../common/constants";
import ClientLookupEventsModal from "./ClientLookupEventsModal";
import {
  clientAddToCart,
  getCustomerCartFull,
  getCustomerCartTab,
  reorderFromFavorites,
  saveCustomerCartItemToTab,
  saveCustomerTabItemToCart,
  saveCustomerTabToCart
} from "../common/api/CartApi";
import {removeFromFavorites, saveCustomerFamily} from "../common/api/CustomerProfileApi";
import Avatar from "@mui/material/Avatar";
import ClientLookupMembershipsModal from "./ClientLookupMembershipsModal";
import ManageAccountModal from "./ManageAccountModal";
import PageLoading from "../common/PageLoading";
import {useForm} from "react-hook-form";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import CartFinal from "../common/cart/CartFinal";
import ViewInventoryModal from "./ViewInventoryModal";
import SquareAddPayment from "../common/SquareAddPayment";
import ViewFamilyMemberNotesModal from "./ViewFamilyMemberNotesModal";
import RegisterEventModal from "../inventory/modal/RegisterEventModal";
import Preview from "../common/modal/preview";
import ActiveMember from "../common/ActiveMember";
import {CompanyContext} from "../../lib/CompanyContext";
import {getInventoryEvent} from "../common/api/InventoryApi";
import {useLastViewed} from "../../lib/LastViewProvider";
import {useKiosk} from "../../lib/KioskModeProvider";
import ClientManageInvoiceModal from "./ClientManageInvoiceModal";
import ManageAccountStartDateModal from "./ManageAccountStartDateModal";
import NoteFlagsModal from "../common/NoteFlagsModal";
import LoopIcon from '@mui/icons-material/Loop';
import ClientAssignPerk from "./ClientAssignPerk";
import DisplayPerk from "../perk/DisplayPerk";
import Button from "@mui/material/Button";
import ViewInvoiceModal from "./ViewInvoiceModal";
import QrCodeIcon from "@mui/icons-material/QrCode";
import GiftCardQrCode from "./GiftCardQrCode";
import CustomerSaleGroupHistory from "./graph/CustomerSaleGroupHistory";
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import ClientChangeLocation from "./ClientChangeLocation";
import {useAccess} from "../../lib/AccessProvider";
import Audit from "../common/Audit";
import ComposeSms from "./ComposeSms";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import ClientMergeInvoices from "./ClientMergeInvoices";
import ConvertInvoiceModal from "./ConvertInvoiceModal";
import ClientManageAccountMembers from "./ClientManageAccountMembers";
import CafeOrderOptionItem from "../company/CafeOrderOptionItem";
import {addDays} from "date-fns";
import CustomerRedeemGiftCard from "./CustomerRedeemGiftCard";

export default function Client(props) {

  const {addCustomer} = useLastViewed();

  const [context, setContext] = useContext(AppContext);
  const myRefs = useRef([]);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [cafeMode, setCafeMode] = useState(false);
  const {toggleKioskMode} = useKiosk();

  const {putClient, clientCallback} = useKiosk();
  const {accessClient, getAccess} = useAccess();

  const customerSetRef = useRef(false);

  const [mounted, setMounted] = useState(false);

  const [redeemGiftCard, setRedeemGiftCard] = useState(false);
  const startRedeemGiftCard = () => {
    setRedeemGiftCard(true);
  }

  useEffect(() => {
    return () => {
      setMounted(false);
      if (customerSetRef.current) {
        putClient(null);
      }
    };
  }, []);

  useEffect(() => {
    if (context?.refresh) {
      let c = {...context};
      c.refresh = false;
      setContext(c);
      setRefreshMember(true);
      setRefreshCart(true);
      setRefreshTab(true);
    }
  }, [context?.refresh])

  useEffect(() => {
    setCafeMode(companyContext?.company?.cafeEnabled || false);
  }, [companyContext?.company]);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const navigate = useNavigate();
  const location = useLocation();
  let {guid} = useParams();

  useEffect(() => {
    if (!guid) {
      setClient({});
      setNewCustomer(true);
      setOnEdit(true);
    }
  }, [guid]);

  const [initialContext, setInitialContext] = useState(true);
  useEffect(() => {
    if (initialContext) {
      setInitialContext(false);
      setSquareEnabled(context?.sessionUser?.company?.paymentExtApplicationId === CONSTANTS.EXT_APPLICATION.SQUARE);
    }
  }, [context]);

  const [squareEnabled, setSquareEnabled] = useState(false);
  const [refreshMember, setRefreshMember] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formInvalid, setFormInvalid] = useState(false);
  const [onEdit, setOnEdit] = useState(guid == null);
  const [newCustomer, setNewCustomer] = useState(guid == null);
  const [client, setClient] = useState(null);
  const [clientCart, setClientCart] = useState(null);
  const [clientTab, setClientTab] = useState(null);
  const [refreshCart, setRefreshCart] = useState(false);
  const [refreshTab, setRefreshTab] = useState(false);
  const [refreshVisits, setRefreshVisits] = useState(false);

  const [clientNotes, setClientNotes] = useState(null);
  const [familyMember, setFamilyMember] = useState(null);
  const [memberAccount, setMemberAccount] = useState(null);
  const [memberBilling, setMemberBilling] = useState(null);
  const [manageMemberBilling, setManageMemberBilling] = useState(false);
  const [composeSms, setComposeSms] = useState(false);
  const [addNote, setAddNote] = useState(false);
  const [clientNote, setClientNote] = useState({});
  const [manageClientNote, setManageClientNote] = useState(null);

  const [noteCount, setNoteCount] = useState(0);
  const [searchNotes, setSearchNotes] = useState(null);

  const [states, setStates] = useState([]);
  const [sysuserVisits, setSysuserVisits] = useState([]);
  const [reservations, setReservations] = useState();
  const [recordingVisit, setRecordingVisit] = useState(false);
  const [lookupEvents, setLookupEvents] = useState(false);
  const [lookupMemberships, setLookupMemberships] = useState(false);
  const [addPerk, setAddPerk] = useState(false);

  const [manageFamilyMember, setManageFamilyMember] = useState(false);
  const [viewFamilyMemberNotes, setViewFamilyMemberNotes] = useState(false);

  const [confirmDeleteMember, setConfirmDeleteMember] = useState(false);
  const [confirmDeleteFamilyMember, setConfirmDeleteFamilyMember] = useState(false);
  const [confirmDeleteNote, setConfirmDeleteNote] = useState(false);
  const [confirmInvoiceReminder, setConfirmInvoiceReminder] = useState(false);
  const [confirmDeletePerk, setConfirmDeletePerk] = useState(false);
  const [confirmDeleteMembership, setConfirmDeleteMembership] = useState(false);
  const [confirmCancelMembership, setConfirmCancelMembership] = useState(false);
  const [confirmDeleteInvoice, setConfirmDeleteInvoice] = useState(false);

  const [confirmDeleteBilling, setConfirmDeleteBilling] = useState(false);
  const [confirmReactivateAccount, setConfirmReactivateAccount] = useState(false);

  const [confirmation, setConfirmation] = useState(null);
  const [manageClientBilling, setManageClientBilling] = useState(null);
  const [manageMemberAccount, setManageMemberAccount] = useState(false);
  const [manageAccountStartDate, setManageAccountStartDate] = useState(false);
  const [clientBilling, setClientBilling] = useState(null);
  const [renderIndex, setRenderIndex] = useState(1);
  const [modalActive, setModalActive] = useState(false);
  const [refreshReservations, setRefreshReservations] = useState(false);
  const [viewingCart, setViewingCart] = useState(false);
  const [clientDisabled, setClientDisabled] = useState(false);

  const [showInventoryModal, setShowInventoryModal] = useState(false);
  const [inventory, setInventory] = useState(null);

  const [activeInvoices, setActiveInvoices] = useState([]);

  useEffect(() => {
    setActiveInvoices(client?.activeInvoices);
  }, [client?.activeInvoices]);

  const [tagName, setTagName] = useState('');
  const [tags, setTags] = useState([]);
  const [showTags, setShowTags] = useState(false);
  const toggleTagsFn = () => {
    setShowTags(!showTags);
  }

  const notesRef = useRef(null);

  const composeSmsFn = () => {
    setComposeSms(true);
  }

  const handleTagChange = (e) => {
    setTagName(e.target.value);
  }

  const removePerkFn = (perk) => {
    removeClientPerk(perk).then(() => {
      getClientMemberPerksFn();
      setConfirmation(null);
      setConfirmDeletePerk(false);
    });
  }

  const sendInvoiceReminder = (perk) => {
    sendInvoiceReminderMessage(perk).then(() => {
      let _context = {...context};
      _context.toast = {
        message: 'Invoice Reminder Sent',
      }
      setContext({..._context});

      setConfirmation(null);
      setConfirmInvoiceReminder(false);

    });
  }

  const removeTagFn = async (tag, index) => {
    removeClientTag(tag).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTags(tags.filter((t, i) => i !== index))
      }
    });
  }
  const saveTagFn = async () => {
    let tag = {
      name: tagName,
      entityType: CONSTANTS.ENTITY_TYPE.CUSTOMER,
      entityId: client?.id,
    }
    saveClientTag(tag).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTagName('');
        setTags([...tags, result]);
      }
    });
  }

  useEffect(() => {
    if (manageFamilyMember || manageClientBilling || manageClientNote || addNote) {
      setModalActive(true);
    } else {
      setModalActive(false);
    }
  }, [manageFamilyMember, manageClientBilling, manageClientNote, addNote]);

  const handleHideDropdown = (event) => {
    if (event.keyCode === 27) {
      for (let ref in myRefs.current) {
        if (!myRefs.current[ref]) {
          return;
        }
        myRefs.current[ref].visible = false;
      }
      setRenderIndex(renderIndex + 1);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
    };
  });

  const toggleLookupEventsFn = () => {
    setLookupEvents(!lookupEvents);
  }

  const toggleCartFn = () => {
    setViewingCart(!viewingCart);
  }

  const removeCustomerPerk = (perk) => {
    let confirmation = {
      title: 'Confirm Delete Perk?',
      message: 'Confirm delete perk ' + perk.name,
      entity: perk
    }
    setConfirmation(confirmation);
    setConfirmDeletePerk(true);
  }

  const [memberPerks, setMemberPerks] = useState();

  const getClientMemberPerksFn = () => {
    getClientMemberPerks(guid).then((resp) => {
      setMemberPerks(resp);
    })
  }

  useEffect(() => {
    if (guid) {
      getCustomerFn().then(result => {
        setMergingInvoices(false);
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          let c = {...result};
          setClient({...c});
          setTags(c?.tags);
          setClientDisabled(c.statusId === CONSTANTS.USER_STATUS.INACTIVE);
          setRefreshMember(false);
          setRefreshCart(true);
          setRefreshTab(true);
          getClientNotesFn();
          getClientMemberPerksFn();
          addCustomer({
            guid: c.guid,
            companyGk: context?.sessionUser?.companyGk,
            name: c?.firstName + ' ' + c?.lastName
          });
          // putClient(c);
        }
      });
    }
  }, [guid, refreshMember]);

  const [toggleTabItems, setToggleTabItems] = useState({});
  const toggleTabItem = (cartItemId) => {
    setToggleTabItems((prev) => ({
      ...prev,
      [cartItemId]: !prev[cartItemId],
    }));
  };

  const [toggleCartItems, setToggleCartItems] = useState({});
  const toggleCartItem = (cartItemId) => {
    setToggleCartItems((prev) => ({
      ...prev,
      [cartItemId]: !prev[cartItemId],
    }));
  };

  useEffect(() => {
    if (!refreshVisits) {
      return;
    }
    setRefreshVisits(false);
    getCustomVisitsFn();
  }, [refreshVisits]);

  useEffect(() => {
    if (!refreshCart) {
      return;
    }
    if (!guid) {
      return;
    }
    getCustomerCartFull(guid).then(result => {
      setClientCart(result);
      setRefreshCart(false);
      setToggleCartItems({});
    });
  }, [refreshCart]);

  useEffect(() => {
    if (!refreshTab) {
      return;
    }
    if (!guid) {
      return;
    }
    getCustomerCartTab(guid).then(result => {
      setClientTab(result);
      setRefreshTab(false);
      setToggleTabItems({});
    });
  }, [refreshTab]);

  useEffect(() => {
    if (!viewingCart) {
      setRefreshCart(true);
    }
  }, [viewingCart]);

  useEffect(() => {
    if (context?.reloadCart) {
      setRefreshCart(true);
    }
  }, [context?.reloadCart]);

  useEffect(() => {
    if (client?.guid) {
      setRefreshReservations(true);
    }
  }, [client?.guid]);

  useEffect(() => {
    if (!refreshReservations) {
      return;
    }
    setRefreshReservations(false);

    setRefreshVisits(true);
    getReservations(guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setReservations(result);
      }
    });
  }, [refreshReservations]);

  useEffect(() => {
    if (!client?.guid) {
      return;
    }
    getClientNotesFn();
  }, [client?.guid, noteCount]);

  const getCustomerFn = async () => {
    return await getCustomer(guid);
  }

  const [viewingInvoice, setViewingInvoice] = useState(false);
  const [invoice, setInvoice] = useState(null);

  const handleRefreshInvoice = (invoice) => {
    getCustomerInvoice(client?.guid, invoice?.invoiceGroupGuid).then((resp) => {
      setInvoice(resp);
    });
  }
  const startConvertInvoice = (_invoice) => {
    setInvoice(_invoice);
    setConvertInvoice(true);
  }

  const viewInvoice = (_invoice) => {
    setInvoice(_invoice);
    setPreviewInvoice(true);
  }

  const cartInvoice = (_invoice) => {
    setViewingInvoice(true);
    setInvoice(_invoice);
    setCartActive(true);
  }

  const startSendInvoiceReminder = (_invoice) => {
    setInvoice(_invoice);
    let confirmation = {
      title: 'Send Invoice Reminder',
      message: 'Confirm send invoice reminder ' + _invoice.referenceId,
      entity: _invoice
    }
    setConfirmation(confirmation);
    setConfirmInvoiceReminder(true);
  };

  const [manageInvoice, setManageInvoice] = useState(false);
  const manageInvoiceFn = (_invoice) => {
    setInvoice(_invoice);
    setManageInvoice(true);
  }


  const getCustomVisitsFn = async () => {
    getVisits(client?.guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setSysuserVisits(result);
      }
    });
  }

  const getClientNotesFn = () => {
    getClientNotes(guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setClientNotes(result);
      }
    });
  }

  const [cartTabActing, setCartTabActing] = useState(false);
  const viewCustomerCart = () => {
    setCartActive(true);
  }

  const viewCustomerTab = () => {
    setCartTabActive(true);
    saveCustomerTabToCart(client).then((resp) => {
      setCartTabActive(false);
      setCartActive(true);
    });
  }

  const addNoteFn = () => {
    setAddNote(true);
    setClientNote(null);
  };

  const manageNoteFn = (note) => {
    setClientNote(note);
    setManageClientNote(true);
  };

  const archiveNoteFn = (note) => {
    setClientNote(note);
    let confirmation = {
      title: 'Confirm Delete note?',
      message: 'Confirm delete note',
      entity: note
    }
    setConfirmation(confirmation);
    setConfirmDeleteNote(true);
  };

  const [showMoveRegistration, setShowMoveRegistration] = useState(false);
  const [reservation, setReservation] = useState(null);

  const startMoveReservation = (reservation) => {
    let _reservation = {...reservation};
    _reservation.event = {
      eventType: reservation.eventType,
      inventoryGuid: reservation?.eventGuid
    };
    setReservation(_reservation);
    setShowMoveRegistration(true);
  }

  const handleMoveReservation = async (event) => {

    setSaving(true);

    let r = {
      reservation: reservation,
      event: event
    }

    let result = await saveMoveEventReservation(r);
    setSaving(false);
    setRefreshReservations(true);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setShowMoveRegistration(false);
      setReservation(null);
    }
  }


  const pauseEmailFn = async () => {
    setSaving(true);

    let result = await pauseEmail(client);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setOnEdit(false);
    }
  }

  const unpauseEmailFn = async () => {
    setSaving(true);

    let result = await unpauseEmail(client);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setOnEdit(false);
    }
  }

  const handleSaveCustomer = async (customer) => {

    setSaving(true);

    let result = await saveCustomer(customer);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setOnEdit(false);
      setNewCustomer(false);

      if (result.guid && guid !== result.guid) {
        navigate('/client/' + result.guid);
      }
    }
  }

  const handleSaveFamilyMember = async (member) => {

    setSaving(true);
    member.parentGuid = client.guid;

    let result = await saveCustomerFamily(member);
    setFamilyMember(null);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setManageFamilyMember(false);
    }
  }

  const handleSaveClientBilling = async (clientBilling) => {

    setSaving(true);
    clientBilling.memberGuid = client.guid;

    let result = await saveClientBilling(clientBilling);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setManageClientBilling(false);
    }
  }

  const handleSaveMemberAccount = async (account) => {

    setSaving(true);

    let result = await saveClientAccount(account);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setManageMemberAccount(false);
      setMemberAccount(null);
    }
  }

  const handleSaveAccountStartDate = async (account) => {

    setSaving(true);

    let result = await saveClientAccountStartDate(account);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setManageAccountStartDate(false);
      setMemberAccount(null);
    }
  }

  const [cartActive, setCartActive] = useState(false);
  const [cartTabActive, setCartTabActive] = useState(false);
  const [previewInvoice, setPreviewInvoice] = useState(false);
  const [convertInvoice, setConvertInvoice] = useState(false);

  const handleCheckout = (response) => {
    setRefreshReservations(true);
    setRefreshCart(true);
    toggleCartFn();
  };

  const [saleHistoryIndex, setSaleHistoryIndex] = useState(1);
  const [fullSalesHistory, setFullSalesHistory] = useState(false);

  const refreshSaleHistory = () => {
    setSaleHistoryIndex(saleHistoryIndex + 1);
  }

  const cartCallback = (callback) => {
    setInvoice(null);
    if (callback.action === 'close') {
      setCartActive(false);
      setCartTabActive(false);
      if (viewingInvoice) {
        setViewingInvoice(false);
      }
      setRefreshMember(true);
    }
    if (callback.action === 'reload') {
      setRefreshReservations(true);
      setRefreshCart(true);
      setRefreshMember(true);
      setSaleHistoryIndex(saleHistoryIndex + 1);
    }
    if (callback.action === 'success') {
      setCartActive(false);
      setCartTabActive(false);
      setRefreshReservations(true);
      setRefreshCart(true);
      setRefreshTab(true);
      refreshSaleHistory();
      setRefreshTab(true);
      setRefreshMember(true);
      let _context = {...context};
      _context.toast = {
        message: 'Sale Successful',
      }
      setContext({..._context});
    }
  }

  const [showRegisterEvent, setShowRegisterEvent] = useState(false);
  const [inventoryEvent, setInventoryEvent] = useState();

  const handleSaveEvent = async (event) => {
    setClient(client);
    let _reservation = {
      eventName: event.name,
      eventGuid: event.guid,
      memberAccount: event.memberAccount
    };
    if (event?.packageRequired) {
      setClient(client);
      toggleLookupEventsFn();
      setInventoryEvent(event);
      setShowRegisterEvent(true);
      return;
    }
    saveClientReservation(client, _reservation).then(result => {
      setRefreshReservations(true);
      setRefreshCart(true);
      toggleLookupEventsFn();
      viewCustomerCart();
    });
  }

  const handleWalkinEvent = async (event) => {
    let _reservation = {
      eventName: event.name,
      eventGuid: event.guid,
      memberAccount: event.memberAccount
    };
    if (event?.packageRequired) {
      setClient(client);
      setLookupEvents(true);
      setInventoryEvent(event);
      setShowRegisterEvent(true);
      return;
    }
    saveClientReservation(client, _reservation).then(result => {
      setRefreshReservations(true);
      setRefreshCart(true);
      viewCustomerCart();
    });
  }

  const togglePinnedNote = (note, idx) => {
    note.pinned = !note.pinned;
    let _notes = [...clientNotes];
    clientNotes[idx] = note;
    setClientNotes(_notes);

    saveClientNote(note).then(r => {

    });
  }

  const pinnedNote = (note) => {
    return note?.pinned ? true : false;
  }

  const handleSaveMembership = async (event) => {
    toggleLookupMembershipsFn();
    setRefreshCart(true);
    viewCustomerCart();
  }

  const handleSaveClientNote = async (note) => {

    setSaving(true);
    note.clientGuid = client.guid;

    let result = await saveClientNote(note);
    setSaving(false);
    setAddNote(false);
    setManageClientNote(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setNoteCount(noteCount + 1);
    }
  }

  const handleCloseNote = () => {
    setFamilyMember(null);
    setManageClientNote(false);
    setAddNote(false);
  }


  const handleClose = () => {
    setOnEdit(false);
    if (newCustomer) {
      if (window.history.length === 1) {
        navigate('/');
      } else {
        window.history.back();
      }
    }
  };

  const handleCloseFamilyMember = () => {
    setFamilyMember(null);
    setManageFamilyMember(false);
  }

  const handleCloseClientBilling = () => {
    setManageClientBilling(false);
  }

  const handleCloseManageAccount = () => {
    setManageMemberAccount(false);
  }

  const handleCancelFamilyMember = () => {
    setConfirmation(null);
    setConfirmDeleteFamilyMember(false);
  }
  const handleCancelMember = () => {
    setConfirmation(null);
    setConfirmDeleteMember(false);
  }

  const handleCancelDeleteBilling = () => {
    setConfirmation(null);
    setConfirmDeleteBilling(false);
  }

  const handleCancelDeleteInvoice = () => {
    setConfirmation(null);
    setConfirmDeleteInvoice(false);
  }

  const makeCardPrimaryFn = async (billing) => {
    setSaving(true);
    let result = await savePrimaryClientBilling(client, billing.guid);
    setSaving(false);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
    }
  };

  const handleConfirmFamilyMember = async (familyMember) => {
    setSaving(true);
    setConfirmDeleteFamilyMember(false);
    let result = await deleteCustomerFamily(client, familyMember);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteFamilyMember(false);
    }
  }

  const handleConfirmDeleteNote = async (note) => {
    setSaving(true);
    let result = await deleteClientNote(note);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteNote(false);
    }
  }

  const handleConfirmMembership = async (membership) => {
    setSaving(true);
    let result = await deleteCustomerMembership(client, membership);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteMembership(false);
    }
  }

  const handleCancelMembership = async (membership) => {
    setSaving(true);
    let result = await cancelCustomerMembership(client, membership);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteMembership(false);
    }
  }


  const handleConfirmMember = async () => {
    setSaving(true);
    setConfirmDeleteFamilyMember(false);
    let result = clientDisabled ? await restoreCustomer(client) : await deleteCustomer(client);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteMember(false);
    }
  }

  const recordVisitFn = async (event, reservation) => {

    if (reservation.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.WALKIN_WAIVER) {
      getInventoryEvent(reservation.eventGuid).then((resp) => {
        handleWalkinEvent(resp);
      });
      return;
    }

    reservation.saving = true;

    setReservations([...reservations]);

    let result = await recordCustomerVisit(client.guid, reservation);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshReservations(true);
      setRefreshMember(true);
    }
  };

  const toggleLookupMembershipsFn = () => {
    setLookupMemberships(!lookupMemberships);
  }

  const addMembershipFn = () => {
    toggleLookupMembershipsFn();
  };

  const toggleAddPerkFn = () => {
    setAddPerk(!addPerk);
  }

  const addMemberPerkFn = () => {
    toggleAddPerkFn();
  };

  const viewFamilyMemberFn = (member) => {
    let m = null;
    if (member) {
      m = {...member};
      if (member.dob) {
        m.dob = new Date(getDateNoTz(member.dob));
      } else {
        m.dob = null;
      }
    }
    setFamilyMember(m);
    setViewFamilyMemberNotes(true);
  };

  const manageFamilyMemberFn = (member) => {
    let m = null;
    if (member) {
      m = {...member};
      if (member.dob) {
        m.dob = new Date(getDateNoTz(member.dob));
      } else {
        m.dob = null;
      }
    }
    setFamilyMember(m);
    setManageFamilyMember(true);
  };

  const displayAccountAccess = (access) => {
    return access.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())).join(', ');
  }

  const manageMemberAccountFn = (account) => {
    setMemberAccount(account);
    setManageMemberAccount(true)
  };

  const manageAccountStartDateFn = (account) => {
    setMemberAccount(account);
    setManageAccountStartDate(true)
  };

  const preDeleteFamilyMemberFn = (member) => {
    let confirmation = {
      title: 'Delete ' + member.firstName + '?',
      message: 'Delete ' + member.firstName + ' ' + member.lastName + ' Permanently?',
      entity: member
    }
    setConfirmation(confirmation);
    setConfirmDeleteFamilyMember(true);
  };

  const preDeleteMembershipFn = (membership) => {
    let confirmation = {
      title: 'Delete ' + membership.accountType?.name + '?',
      message: 'Delete ' + membership.accountType?.name + ' Permanently?',
      entity: membership
    }
    setConfirmation(confirmation);
    setConfirmDeleteMembership(true);
  };

  const preCancelMembershipFn = (membership) => {
    let cancelMessage = 'Cancel ' + membership.accountType?.name + ' Membership?';
    let cancelHtml = null;
    if (membership?.minimumCancellationDate && new Date(membership?.minimumCancellationDate).getTime() > new Date().getTime()) {
      cancelHtml = <div><p><b>Minimum commitment not yet met.</b></p>
        <p>This membership has a minimum commitment through {formatDate(membership?.minimumCancellationDate)}.</p>
        <p>Cancelling this membership now will end the membership before the minimum commitment has been fulfilled.</p>
        <p><b>Are you sure you want to continue?</b></p>
      </div>;
      cancelMessage = null;
    }
    let confirmation = {
      title: 'Cancel ' + membership.accountType?.name + '?',
      message: cancelMessage,
      htmlMessage: cancelHtml,
      entity: membership
    }
    setConfirmation(confirmation);
    setConfirmCancelMembership(true);
  };

  const preDeleteInvoiceFn = (invoice) => {
    let messagePart = invoice?.invoiceGroup ? invoice?.referenceId : invoice.inventoryItem.name;
    let confirmation = {
      title: 'Archive Invoice?',
      message: 'Archive ' + messagePart + '?',
      entity: invoice
    }
    setConfirmation(confirmation);
    setConfirmDeleteInvoice(true);
  };

  const preDeleteBillingFn = (card) => {
    let confirmation = {
      title: 'Delete Card?',
      message: 'Delete Card Permanently?',
      entity: card
    }
    setConfirmation(confirmation);
    setConfirmDeleteBilling(true);
  };

  const handleConfirmDeleteBilling = async (billing) => {
    setSaving(true);
    setConfirmDeleteBilling(false);
    let result = await deleteCustomerBilling(client, billing);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteBilling(false);
    }
  }

  const handleConfirmDeleteInvoice = async (invoice) => {
    setSaving(true);
    setConfirmDeleteInvoice(false);
    let result = await invoice?.invoiceGroup ? deleteCustomerInvoiceGroup(client, invoice) : deleteCustomerInvoice(client, invoice);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshMember(true);
      setConfirmDeleteInvoice(false);
    }
  }

  const toggleEntityActions = (entity, show, hide) => {
    if (show) {
      entity.showActions = true;
    } else if (hide) {
      entity.showActions = false;
    } else {
      entity.showActions = !!!entity.showActions;
    }
    setRenderIndex(renderIndex + 1);
  }

  const highlight = (haystack) => {
    const needle = searchNotes;
    if (!needle) {
      return haystack;
    }
    var querystr = needle;
    var result = haystack;
    var reg = new RegExp(querystr.split(' ').join('|'), 'gi');
    var final_str = result.replace(reg, function (str) {
      return '<b>' + str + '</b>'
    });

    return final_str;

  }

  const matchNotes = (note) => {
    let notes = searchNotes.split(' ');
    let match = true;
    notes.forEach(n => {
      let fam = '';
      if (note?.familyNoteMember) {
        fam += note?.familyNoteMember?.firstName + ' ' + note?.familyNoteMember?.lastName;
      }
      if (fam.toLowerCase().includes(n.toLowerCase())) {
        match = true;
      } else if (!note.note.toLowerCase().includes(n.toLowerCase())) {
        match = false;
      }
    });
    return match;
  }

  const undeleteClient = () => {
    let confirmation = {
      title: 'Restore Client?',
      message: 'Restore Client',
      entity: client
    }
    setConfirmation(confirmation);
    setConfirmDeleteMember(true);
  }

  const confirmDeleteClient = () => {
    let confirmation = {
      title: 'Archive Client?',
      message: 'Confirm Archive Client?',
      entity: client
    }
    setConfirmation(confirmation);
    setConfirmDeleteMember(true);
  }

  const undoCheckinFn = async (reservation) => {
    reservation.cancelling = true;
    checkOutClientReservation(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshReservations(true);
      }
    });
  }

  const cancelReservationFn = async (reservation) => {
    reservation.cancelling = true;
    cancelClientReservation(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshReservations(true);
      }
    });
  }

  const noShowReservationFn = async (reservation) => {
    reservation.cancelling = true;
    noShowClientReservation(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshReservations(true);
      }
    });
  }

  const sendToCartFn = (item) => {
    let _item = {...item};
    clientAddToCart(_item, client?.guid).then(resp => {
      let _context = {...context};
      _context.toast = {
        message: 'Added to cart',
      }
      setContext({..._context});
      setRefreshCart(true);
    });
  }

  const [showConfirm, setShowConfirm] = useState(false);

  const preDeleteInventoryItem = (item) => {
    let confirmation = {
      title: 'Delete?',
      message: 'Remove ' + item.inventoryItem.name + ' from cart?',
      entity: item
    }
    setConfirmation(confirmation);
    setShowConfirm(true);
  };

  const moveCartItemToTab = (item) => {
    toggleCartItem(item.cartItemId);
    let _cart = {...clientCart};
    _cart.items.push({
      cartItemId: -1,
      inventoryItem: {
        name: '...'
      }
    });
    setClientCart(_cart);
    toggleTabItem(-1);
    saveCustomerCartItemToTab(client, item).then((resp) => {
      setRefreshTab(true);
      setRefreshCart(true);
    });
  }

  const moveTabItemToCart = (item) => {
    toggleTabItem(item.cartItemId);
    let _cart = {...clientCart};
    _cart.items.push({
      cartItemId: -1
    });
    setClientCart(_cart);
    toggleCartItem(-1);

    saveCustomerTabItemToCart(client, item).then((resp) => {
      setRefreshTab(true);
      setRefreshCart(true);
    });
  }

  const [waiverPreview, setWaiverPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);

  const [membershipMembers, setMembershipMembers] = useState({});

  const [accountMembership, setAccountMembership] = useState();
  const [isManageMemberAccount, setIsManageMemberAccount] = useState(false);

  const handleSaveMembershipAccount = async (event) => {
    setAccountMembership(null);
    setIsManageMemberAccount(false);
    setRefreshMember(true);
  }

  const startManageAccountMembers = (account) => {
    setAccountMembership(account);
    setIsManageMemberAccount(true);
  }

  const viewWaiver = async (item) => {
    previewClientWaiver(client, item.guid).then((result) => {
      setWaiverPreview(result);
      setShowPreview(true);
    });
  }

  const downloadWaiver = async (item) => {
    getClientWaiver(client, item.guid).then((result) => {
      let blob = new Blob([result], {type: 'application/pdf'});
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, item.waiverName + '.pdf');
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", item.waiverName + '.pdf');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }
  const deleteInventoryItem = async (item) => {
    removeCartItem(item).then((result) => {
      let _context = {...context};
      _context.reloadCart = true;
      setContext({..._context});
      handleCancelCartRemove();
      setRefreshCart(true);
      setRefreshTab(true);
    });
  };

  const handleCancelCartRemove = () => {
    setConfirmation(null);
    setShowConfirm(false);
  }

  const NoteItemActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageNoteFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                archiveNoteFn(item)
              }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }


  const [mergeInvoices, setMergeInvoices] = useState(false);
  const toggleMergeInvoices = () => {
    setMergeInvoices(!mergeInvoices);
  }

  const canMergeInvoices = () => {
    return (invoicesToMerge?.length + invoiceGroupsToMerge?.length) > 1
  }

  const [invoicesToMerge, setInvoicesToMerge] = useState([]);
  const [invoiceGroupsToMerge, setInvoiceGroupsToMerge] = useState([]);

  const [mergingInvoices, setMergingInvoices] = useState(false);
  const [confirmMergeInvoices, setConfirmMergeInvoices] = useState(false);

  const handleSaveMergeInvoices = (data) => {
    setMergingInvoices(true);
    let _invoices = [];
    invoicesToMerge.map((inv) => {
      _invoices.push(inv.invoiceGuid);
    });
    let _invoiceGroups = [];
    invoiceGroupsToMerge.map((inv) => {
      _invoiceGroups.push(inv.invoiceGroupGuid);
    });
    let mergeRequest = {
      invoiceGuids: _invoices,
      invoiceGroupGuids: _invoiceGroups,
      client: client,
      dueDate: data.dueDate
    }

    mergeCustomerInvoices(mergeRequest).then((resp) => {
      setRefreshMember(true);
      setSaving(false);
      setMergeInvoices(false);
      setMergingInvoices(false);
      setConfirmMergeInvoices(false);
      setInvoicesToMerge([]);
      setInvoiceGroupsToMerge([]);
    });
  }

  const toggleInvoiceOption = (option) => {
    let options = [...invoicesToMerge];
    if (invoiceSelected(option)) {
      let _newOptions = options.filter((opt) => opt.id !== option.id);
      setInvoicesToMerge(_newOptions);
    } else {
      options.push(option);
      setInvoicesToMerge(options);
    }
  }

  const toggleInvoiceGroupOption = (option) => {
    let options = [...invoiceGroupsToMerge];
    if (invoiceGroupSelected(option)) {
      let _newOptions = options.filter((opt) => opt.id !== option.id);
      setInvoiceGroupsToMerge(_newOptions);
    } else {
      options.push(option);
      setInvoiceGroupsToMerge(options);
    }
  }

  const invoiceSelected = (item) => {
    return invoicesToMerge.filter((inv) => inv.id === item.id)?.length > 0;
  }

  const invoiceGroupSelected = (item) => {
    return invoiceGroupsToMerge.filter((inv) => inv.id === item.id)?.length > 0;
  }

  const getNextBillingDate = (account) => {
    let d = new Date();
    let minCancelDate = addDays(d, account?.minimumCancellationDays || 0);

    let billingEndDate = null;
    if (account.billingEndDate) {
      billingEndDate = new Date(account.billingEndDate);
    }

    let dd;
    if (!account.nextBillDate) {
      d.setDate(account.billingDayOfMonth || 1);
      dd = addDays(d, 30);
    } else {
      let nextBillingDate = new Date(account.nextBillDate);
      if (minCancelDate.getTime() > nextBillingDate.getTime()) {
        dd = addDays(nextBillingDate, 30);
      } else {
        dd = minCancelDate;
      }
    }
    if (billingEndDate != null && billingEndDate.getTime() <= dd.getTime()) {
      return billingEndDate;
    }
    return new Date(dd.getTime());
  }

  const InvoiceActions = ({item, index}) => {
    return (<PopupState variant="popover" popupId={'invoice-popup-menu-' + index}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                viewInvoice(item)
              }} icon={<Icon>launch</Icon>} title="View Invoice"/>

            {context?.sessionUser?.adminUser?.superAdmin && item.versionId === 1 && <NotificationItem
              style={{
                background: '#eed202'
              }}
              onClick={(e) => {
                popupState.close();
                let _item = {...item}
                _item.convertInvoice = true;
                startConvertInvoice(_item);
              }} icon={<Icon>launch</Icon>} title="Convert Invoice Group"/>}

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                cartInvoice(item)
              }} icon={<Icon>receipt</Icon>} title="Charge Now"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startSendInvoiceReminder(item)
              }} icon={<Icon>notifications</Icon>} title="Send Reminder"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageInvoiceFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                preDeleteInvoiceFn(item)
              }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const ReservationAddons = ({reservation}) => {
    return (
      <div className={'d-block mt-1'}>
        <Icon>access_time</Icon>&nbsp;{formatDateTime(reservation?.eventDate)}

        {reservation?.eventPackageName &&
          <b><br/>Package - {reservation?.eventPackageName}</b>}

        {reservation?.reservationPurchaseItems?.length > 0 && <>
          <br/>{reservation.reservationPurchaseItems.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).map((item, idx) => {
          return (<span key={idx}>
                                                {idx === 0 ? '' : ', '}{item.name}
                                                </span>)
        })}</>}
      </div>
    )
  }

  const NoteItem = ({note, index}) => {
    return (<li
      className={'list-group-item hover-bg-soft ' + (searchNotes && !matchNotes(note) ? 'd-none' : '')}
      key={index}>
<span className="pull-right">
         <NoteItemActions item={note}/>
        </span>

      <p>
        {note?.familyNoteMember && <span
          className={"fst-italic"}
          dangerouslySetInnerHTML={{__html: highlight('(' + note?.familyNoteMember?.firstName + ' ' + note?.familyNoteMember?.lastName + ') ')}}/>
        }
        <span
          dangerouslySetInnerHTML={{__html: highlight(note.note)}}/>
      </p>
      <Chip
        onClick={() => {
          togglePinnedNote(note, index);
        }}
        label={<>
          {!note.pinned ?
            <span
              style={{
                transform: 'rotate(15deg)'
              }}
              className="font-color-grey fa fa-thumbtack"></span>
            :
            <span
              className="font-color-gold fa fa-thumbtack"></span>
          }</>}
        variant="outlined"
      />&nbsp;
      {note?.noteFlag && <><Chip
        label={<span
          className="font-color-gold fa fa-flag"></span>}
        variant="outlined"
      />
        &nbsp;</>
      }
      <Chip
        label={<>By: {note.createUser.firstName + ' ' + note.createUser.lastName} On: {formatDateTime(note.createDate)}</>}
        variant="outlined"
      />&nbsp;
      {note.reminderNote && <>
        <Chip
          label={<>Reminder Date: {formatDate(note.reminderDate)}</>}
          variant="outlined"
        />&nbsp;
      </>
      }
    </li>);
  }

  const [showFlags, setShowFlags] = useState(false);
  const [expandBilling, setExpandBilling] = useState(false);
  const [addPayment, setAddPayment] = useState(false);

  const toggleFlags = () => {
    setShowFlags(true);
  }

  const clientFlags = (clientNotes) => {
    let hasFlags = false;
    clientNotes?.map((a, b) => {
      if (a.noteFlag) {
        hasFlags = true;
      }
    })
    return hasFlags;
  }


  const [showGiftCardQR, setShowGiftCardQR] = useState(false);
  const [giftCardQrCode, setGiftCardQrCode] = useState(null);

  const printQrGiftCard = (card) => {
    setShowGiftCardQR(true);
    setGiftCardQrCode(card);
  }

  const giftCardBalance = (client) => {
    let _d = 0;
    client?.giftCards?.map((a, b) => {
      _d += a.currentBalance
    });
    if (_d <= 0) {
      return '';
    }

    return ' - Total: ' + (formatCurrency(_d));
  }

  const customerName = (client) => {
    let name = (!client || !client?.guid) ? 'New Customer' : 'View Customer';

    if (!client) {
      return name;
    }
    if (!client?.firstName || !client?.lastName) {
      return name;
    }

    return name + ' - ' + client.firstName + ' ' + client.lastName;
  }

  const reservationDisabled = (reservation) => {
    let id = reservation?.reservationStatus?.id;
    return id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN
      || id === CONSTANTS.RESERVATION_STATUS.CANCELLED
      || id === CONSTANTS.RESERVATION_STATUS.EVENT_CANCELLED;
  }

  const InvoiceItem = ({item, group}) => {
    return (<>
      {group && <>
        {item.inventoryItem.name}
        {item.membershipInvoice && <>
          <Chip label={item.membershipName} icon={<Icon>loop</Icon>}
                color="warning"/>
        </>
        }
      </>}
      {!group && <>
        <a href={'#'} onClick={(e) => {
          e.preventDefault();
          group ? manageInvoiceFn(item) : viewInvoice(item);
        }}>
          {item.referenceId}
          {context?.sessionUser?.adminUser?.superAdmin && item.versionId === 1 && <Icon>new_releases</Icon>}
        </a>
        <p className={'m-0'}><b>Due Date:</b> {formatDate(item.dueDate)}</p>
      </>}
      {!group && <p className={'m-0'}>
        <b>Amount Due:</b> {formatCurrency(item.amountDue - item.discountAmount)}
      </p>}
      <div className={'d-block clear clearfix'}>
        <span
          className={'badge badge-primary bg-light-info text-black-50 fs--2'}>{item?.reservationStatus?.name}</span>
        {item.inventoryItem?.eventDate && <small>
          {formatDateTime(item.inventoryItem.eventDate, 'hh:mm a')} - {formatDateTime(item.inventoryItem.eventEndDate, 'hh:mm a')}
        </small>
        }
      </div>
    </>)
  }

  const nextBillingDate = (account) => {
    let nextBillDate = account?.nextBillDate;
    if (!nextBillDate) {
      return false;
    }
    let billEndDate = account.billingEndDate;
    if (!billEndDate) {
      return true;
    }
    if (new Date(nextBillDate).getTime() > new Date(billEndDate).getTime()) {
      return false;
    }
    return true;
  }
  const [membershipTabActive, setMembershipTabActive] = useState('active');

  const {register, handleSubmit, setValue} = useForm({});

  const [orgAccess, setOrgAccess] = useState(null);

  useEffect(() => {
    if (!client || !companyContext) {
      return;
    }
    setOrgAccess(getAccess(client));
  }, [client]);

  const [changeLocation, setChangeLocation] = useState(false);

  const promptChangeLocation = () => {
    setChangeLocation(true);
  }

  const fasStyleEnabled = {
    textTransform: 'inherit',
    fontWeight: 'normal',
    float: 'right',
  }

  const fasStyleDisabled = {
    border: 'solid 1px #ccc !important',
    fontWeight: 'normal',
    color: '#333 !important',
    background: '#eaeaea !important',
    textTransform: 'inherit',
    float: 'right',
  }

  const reorderFromFavoritesFn = (item) => {
    reorderFromFavorites(client?.guid, item).then((resp) => {
      viewCustomerCart();
    });
  }

  const removeFromFavoritesFn = (saleItem) => {
    removeFromFavorites(client?.guid, saleItem).then((resp => {
      setRefreshMember(true);
    }))
  }

  const FavoritesItemActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'favorites-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                reorderFromFavoritesFn(item)
              }} icon={<Icon>star</Icon>} title={"Reorder"}/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                removeFromFavoritesFn(item)
              }} icon={<Icon>delete</Icon>} title={"Remove From Favorites"}/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  return (
    <>

      {newCustomer && <Meta pageTitle={'New Customer'}/>}
      {!newCustomer && client && <Meta
        pageTitle={(client ? ('View Customer - ' + client?.firstName + ' ' + client?.lastName) : 'View Customer') + (clientDisabled ? ' (Disabled)' : '')}/>}

      <DashboardLayout>

        <ContextSearchNavbar
          title={(!client?.guid && !newCustomer) ? "" : customerName(client)} isClient={false}/>

        <MDBox py={3}>
          <MDBox mb={3}>
            {(!client?.guid && !newCustomer) && <>
              <PageLoading/>
            </>}

            {client?.guid && <>
              <Row>
                <Col sm={12}>
                  <Row>
                    <Col sm={6} xs={12}>
                      <Card>
                        <CardContent style={{position: 'relative'}}>

                          <h3 className={'mb-2'}>
                            <Badge className={'mr-2'}>
                              <Avatar alt={client?.email} style={{
                                backgroundColor: colorize(client?.email),
                              }}>
                                {customerInitials(client)}
                              </Avatar>
                              &nbsp;
                            </Badge>

                            {client.firstName} {client.lastName}

                            <span>
                              <ActiveMember client={client} style={{
                                float: 'none',
                                fontSize: '16px',
                                display: 'inline',
                                position: 'relative',
                                top: '-8px'
                              }}/>
                            </span>

                            <div className={'pull-right'} ref={el => (myRefs.current['clientActions'] = el)}
                                 onClick={(e) => {
                                   refHandler('clientActions')
                                 }}>

                              <MDButton
                                variant="outlined"
                                color="secondary"
                                size="small"
                                circular
                                iconOnly
                              >
                                <Icon>more_horiz</Icon>
                              </MDButton>

                              {renderIndex && myRefs.current['clientActions']?.visible &&
                                <Menu open={true} anchorReference={null} anchorEl={myRefs.current['clientActions']}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                      }}>

                                  <NotificationItem
                                    disabled={clientDisabled}
                                    onClick={(e) => {
                                      setOnEdit(true);
                                    }} icon={<Icon>edit</Icon>} title="Edit"/>

                                  <NotificationItem
                                    disabled={clientDisabled}
                                    onClick={(e) => {
                                      addMemberPerkFn();
                                    }} icon={<span className={'fa fa-trophy'}></span>} title="Add Perk"/>

                                  {orgAccess?.ready && orgAccess?.orgOwner &&
                                    <NotificationItem
                                      disabled={clientDisabled}
                                      onClick={(e) => {
                                        promptChangeLocation();
                                      }} icon={<OtherHousesIcon/>} title="Change Home Location"/>
                                  }


                                  <NotificationItem
                                    disabled={client?.emailPaused}
                                    onClick={(e) => {
                                      pauseEmailFn()
                                    }} icon={<Icon>pause</Icon>}
                                    title={client.emailPaused ? 'Emails Paused' : 'Pause Emails'}/>

                                  {client?.emailPaused &&
                                    <NotificationItem
                                      disabled={clientDisabled}
                                      onClick={(e) => {
                                        unpauseEmailFn()
                                      }} icon={<Icon>pause_circle</Icon>} title="Resume Emails"/>
                                  }

                                  <NotificationItem
                                    disabled={clientDisabled}
                                    onClick={(e) => {
                                      confirmDeleteClient()
                                    }} icon={<Icon>delete</Icon>} title="Archive"/>

                                  {clientDisabled && <NotificationItem onClick={(e) => {
                                    undeleteClient()
                                  }} icon={<Icon>restore</Icon>} title="Restore"/>}
                                </Menu>
                              }
                            </div>
                          </h3>
                          {orgAccess?.ready && <div className={'my-2'}>
                            <Fab variant="extended" color="secondary" size={"small"} sx={
                              orgAccess?.orgOwner ? fasStyleEnabled : fasStyleDisabled
                            }
                                 disabled={!orgAccess?.orgOwner}
                                 onClick={() => {
                                   promptChangeLocation()
                                 }}>
                              <OtherHousesIcon/>&nbsp;{orgAccess?.companyName}
                            </Fab>
                            <div style={{
                              display: 'block',
                              clear: 'both'
                            }}></div>
                          </div>
                          }

                          <h6>
                            {client.email && <>
                              {(client.emailEnabled && !client.emailPaused) &&

                                <Link to={'/email/client/' + client.guid + '?address=' + client.email}
                                      className={'ml-2'}>
                                  <Icon sx={{
                                    position: 'relative',
                                    top: '2px'
                                  }}>email</Icon> {client.email}
                                </Link>
                              }
                              {(!client.emailEnabled || client.emailPaused) &&
                                <>
                                  <OverlayTrigger
                                    placement={'right'}
                                    delay={{show: 250, hide: 400}}
                                    overlay={
                                      <Tooltip>
                                        Email {client.emailPaused ? 'Paused' : 'Disabled'}
                                      </Tooltip>
                                    }>
                                    <span>{client.email}</span>
                                  </OverlayTrigger>
                                </>
                              }
                            </>
                            }
                          </h6>

                          {clientFlags(clientNotes) ? <>

                            <OverlayTrigger
                              placement={'top'}
                              delay={{show: 250, hide: 400}}
                              overlay={
                                <Tooltip>
                                  Flagged Notes
                                </Tooltip>
                              }>
                              <MDButton
                                variant="contained"
                                color="info"
                                size="small"
                                circular
                                iconOnly
                                onClick={() => {
                                  toggleFlags()
                                }}
                              >
                                <span className={'fa fa-flag'}></span>
                              </MDButton>
                            </OverlayTrigger>

                            &nbsp;
                          </> : <></>}

                          {clientNotes?.length > 0 && <>
                            <OverlayTrigger
                              placement={'top'}
                              delay={{show: 250, hide: 400}}
                              overlay={
                                <Tooltip>
                                  View Notes
                                </Tooltip>
                              }>
                              <MDButton
                                title={"View Notes"}
                                variant="contained"
                                color="secondary"
                                size="small"
                                circular
                                iconOnly
                                onClick={() => {
                                  notesRef.current?.scrollIntoView({behavior: 'smooth'});
                                }}
                              >
                                <Icon>speaker_notes</Icon>
                              </MDButton>
                            </OverlayTrigger>
                            &nbsp;
                          </>}
                          {client?.firstTimeGuest && <>
                            <Chip
                              label={'First Visit'}
                              icon={<Icon>star</Icon>}
                              color="primary"
                              size="medium"
                            />&nbsp;
                          </>
                          }
                          <Chip
                            label={'Member Since: ' + formatDate(client.createDate)}
                            icon={<Icon>person</Icon>}
                            color="primary"
                            variant="outlined"
                            size="medium"
                          />&nbsp;
                          {client?.referralType && <Chip
                            label={'Referral Type: ' + client?.referralType.name}
                            icon={<Icon>chat</Icon>}
                            color="primary"
                            variant="outlined"
                            size="medium"
                          />}
                          <Divider/>
                          <Col sm={12}>
                            <div
                              style={{
                                height: "auto", margin: "0 auto",
                                padding: '0px 10px 0 0',
                                float: 'right',
                                maxWidth: 62, width: "100%"
                              }}>
                              <QRCode
                                size={256}
                                style={{height: "auto", display: "none", maxWidth: "100%", width: "100%"}}
                                value={customerQrCode(client)}
                                viewBox={'0 0 256 256'}/>
                            </div>
                          </Col>
                          <p>
                            {client?.address1 && <Icon sx={{
                              position: 'relative',
                              top: '2px'
                            }}>place</Icon>} {client.address1} {client.address2}
                            {(client?.address1?.length > 0 || client?.address2?.length > 0) && <br/>}
                            {client.city}{client?.city && client?.state ? ', ' : ''}
                            {client.state?.stateId > -1 && client.state.stateName} {client.zipCode}
                          </p>
                          {client.primaryPhone &&
                            <p>
                              <Icon sx={{
                                position: 'relative',
                                top: '2px'
                              }}>phone_iphone</Icon>{displayPhone(client.primaryPhone)}
                            </p>
                          }

                          <Divider/>

                          <Row className={'mb-4'}>
                            <Col sm={12}>
                              <MDTypography variant="h6" fontWeight="bold">Tags
                                <Chip
                                  label={!showTags ? 'Add Tag' : 'Close'}
                                  icon={!showTags ? <Icon>add_circle</Icon> : <Icon>cancel</Icon>}
                                  color="primary"
                                  className="pull-right"
                                  size="small"
                                  onClick={() => {
                                    toggleTagsFn()
                                  }}
                                /></MDTypography>
                              {showTags && <form onSubmit={handleSubmit(saveTagFn)}>
                                <FormControl variant="outlined" p={0}
                                             className="form-inline d-block mt-2 mb-2">
                                  <InputLabel htmlFor="tag-input">Tag</InputLabel>
                                  <OutlinedInput
                                    autoFocus
                                    autoComplete={'off'}
                                    id="tag-input"
                                    type={'text'}
                                    value={tagName}
                                    onChange={handleTagChange}

                                    endAdornment={
                                      <InputAdornment position="end">
                                        <MDButton
                                          color="primary"
                                          size="small"
                                          disabled={!tagName}
                                          onClick={handleSubmit(saveTagFn)}
                                          className={'btn btn-primary'}
                                        >Save</MDButton>
                                      </InputAdornment>
                                    }
                                    label="Tag"
                                  />
                                </FormControl>
                              </form>
                              }
                              {tags?.length === 0 && <ul className={'list-group'}>
                                <li className={'list-group-item'}>
                                  <center>No customer tags</center>
                                </li>
                              </ul>
                              }
                              {tags?.length > 0 && tags.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1).map((tag, index) => {
                                return (
                                  <span key={index}>
                           <Chip
                             label={tag.name}
                             onDelete={() => {
                               removeTagFn(tag, index);
                             }}
                             onClick={() => {
                               navigate(`/tags/report/${tag.name}`)
                             }}
                             color="primary"
                             variant="outlined"
                           />&nbsp;
                         </span>
                                )
                              })
                              }
                            </Col>
                          </Row>

                          {renderIndex > 0 && <div className="mb-3 psb-bordered">
                            <h6>
                              Gift Cards {giftCardBalance(client)}
                              <ButtonGroup className={'pull-right'}>
                                <MDButton color="primary"
                                          size="small"
                                          className="mx-1"
                                          onClick={() => {
                                            putClient(client);
                                            toggleKioskMode('gift-cards');
                                          }}><span className={'fa fa-id-card'}></span>&nbsp;Add Gift Card
                                </MDButton>

                                <MDButton color="primary"
                                          size="small"
                                          onClick={() => {
                                            startRedeemGiftCard();
                                          }}><span className={'fa fa-barcode'}></span>&nbsp;Redeem Gift Card
                                </MDButton>

                              </ButtonGroup>
                            </h6>
                            <div className={'my-1'}>&nbsp;</div>
                            {client?.giftCards
                              .sort((a, b) => new Date(a.createDate).getTime() - new Date(b.createDate).getTime())
                              .map((card, index) => {
                                return (<span key={index}>
                                  {(card.physicalGiftCard || card.transferred) ?
                                    <Chip
                                      color="secondary"
                                      variant="outlined"
                                      label={card.name + ' - ' + (formatCurrency(card.currentBalance))}
                                    /> :
                                    <Chip
                                      deleteIcon={<QrCodeIcon/>} onDelete={() => {
                                      printQrGiftCard(card)
                                    }}
                                      color="secondary"
                                      variant="outlined"
                                      label={card.name + ' - ' + (formatCurrency(card.currentBalance))}
                                    />
                                  }

                                  &nbsp;</span>);
                              })}
                          </div>
                          }
                          <div className="mb-3 psb-bordered">
                            <h6>
                              Billing Information&nbsp;
                              {squareEnabled &&
                                <MDButton color="primary"
                                          size="small"
                                          className="pull-right"
                                          onClick={() => {
                                            setAddPayment(true);
                                          }}><span className={'fa fa-credit-card'}></span>&nbsp;Add Payment method
                                </MDButton>}
                            </h6>
                            <Row style={{
                              display: 'block',
                              clear: 'both',
                              marginTop: '8px'
                            }}>
                              <Col sm={12}>

                                <ul className={'list-group'}>
                                  {client?.clientBilling?.length === 0 && <li className={'list-group-item'}>
                                    <center>No billing info</center>
                                  </li>
                                  }
                                  {client?.clientBilling
                                    .filter((item) => expandBilling ? 1 == 1 : item.primaryCard)
                                    .sort((a, b) => a.id > b.id ? 1 : -1)
                                    .map((billing, index) => {
                                      return (<li className={'list-group-item'}
                                                  style={{
                                                    'position': 'relative',
                                                  }}

                                                  key={index}>
                                    <span
                                      className={'mx-2 fa fa-credit-card'}></span>
                                          {billing.billingName} {billing.cardNumber} ({billing.ccExpy})

                                          <div className={'pull-right px-2'}
                                               onClick={(e) => {
                                                 refHandler('clientBilling' + index)
                                               }}
                                               ref={el => (myRefs.current['clientBilling' + index] = el)}>

                                            <MDButton
                                              variant="outlined"
                                              color="secondary"
                                              size="small"
                                              circular
                                              iconOnly
                                            >
                                              <Icon>more_horiz</Icon>
                                            </MDButton>
                                            {renderIndex && myRefs.current['clientBilling' + index]?.visible &&
                                              <Menu open={true} anchorReference={null}
                                                    anchorEl={myRefs.current['clientBilling' + index]}
                                                    anchorOrigin={{
                                                      vertical: "bottom",
                                                      horizontal: "left",
                                                    }}>

                                                <NotificationItem onClick={(e) => {
                                                  e.preventDefault();
                                                  preDeleteBillingFn(billing);
                                                }} icon={<Icon>delete</Icon>}
                                                                  title="Delete"/>
                                              </Menu>
                                            }
                                          </div>
                                          {billing.primaryCard && <>
                                            <br/><span
                                            className={'badge badge-primary bg-light-info text-black-50 fs--2 mr-2'}>
                                          Primary
                                      </span>
                                          </>}
                                        </li>
                                      );
                                    })}
                                </ul>
                              </Col>
                            </Row>
                          </div>

                        </CardContent>
                      </Card>


                      {memberPerks?.length > 0 && <Card className={'mt-4'}>
                        <CardContent>
                          <h5>
                            Member Perks

                            <MDButton
                              color="secondary"
                              size="small"
                              disabled={clientDisabled}
                              className={'pull-right'}
                              onClick={(e) => {
                                addMemberPerkFn();
                              }}>
                              <span className={'fa fa-trophy'}></span>&nbsp;Add Perk
                            </MDButton>

                          </h5>
                          <Divider/>
                          <Row>
                            <Col sm={12}>
                              <ul className={'list-group'}>
                                {memberPerks?.map((perk, idx) => {
                                  return (
                                    <li
                                      className={'list-group-item'}
                                      key={idx}>
                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                        className={'pull-right'}
                                        onClick={() => {
                                          removeCustomerPerk(perk)
                                        }}
                                      >
                                        <Icon>close</Icon>
                                      </MDButton>

                                      <DisplayPerk key={idx} perk={perk}/>
                                    </li>
                                  )
                                })
                                }
                              </ul>
                            </Col>
                          </Row>
                        </CardContent>
                      </Card>
                      }

                      {activeInvoices &&
                        <>
                          <Card className={'my-4'}>
                            <CardContent>
                              <h5>
                                Open Invoices
                                {activeInvoices?.length > 1 && <ButtonGroup className="pull-right">
                                  <MDButton
                                    onClick={() => {
                                      toggleMergeInvoices();
                                    }}
                                    color="info"
                                    size="small"
                                    className="pull-right"
                                    variant="contained">{mergeInvoices ? 'Cancel' : 'Merge Invoices'}</MDButton>
                                  {mergeInvoices &&
                                    <MDButton
                                      onClick={() => {
                                        setConfirmMergeInvoices(true);
                                      }}
                                      disabled={!canMergeInvoices()}
                                      color="primary"
                                      size="small"
                                      className="pull-right"
                                      variant="contained">Save Merged Invoices</MDButton>
                                  }
                                </ButtonGroup>
                                }
                              </h5>
                              <Divider/>

                              <div className={'d-block mb-1'}>
                                {activeInvoices.length === 0 && <>
                                  <div className={'group-item'}>
                                    <center>No open invoices</center>
                                  </div>
                                </>}
                                {activeInvoices?.sort((a, b) => new Date(b.dueDate).getTime() - new Date(a.dueDate).getTime()).map((item, index) => {
                                    return (
                                      <div
                                        className={'psb-bordered p-2'}
                                        key={index}>
                                        <Grid container>
                                          {mergeInvoices &&
                                            <Grid p={0} m={0} item sm={mergeInvoices ? 1 : 0} xs={mergeInvoices ? 2 : 0}>
                                              <Checkbox key={'merge-invoices-' + index}
                                                        checked={item?.invoiceGroup ? invoiceGroupSelected(item) : invoiceSelected(item)}
                                                        onChange={(e) => {
                                                          item?.invoiceGroup ? toggleInvoiceGroupOption(item) : toggleInvoiceOption(item)
                                                        }}
                                              />
                                            </Grid>}
                                          <Grid item sm={mergeInvoices ? 11 : 12} xs={mergeInvoices ? 10 : 12}>
                                            <span
                                              className={'pull-right'}>
                                           <span className="d-block pull-right px-2 cursor-pointer">
                                              <InvoiceActions item={item} index={index}/>
                                            </span>
                                        </span>
                                            {item?.invoiceGroup && <>
                                              <a href={'#'} onClick={(e) => {
                                                e.preventDefault();
                                                viewInvoice(item);
                                              }}>
                                                {item.referenceId}
                                              </a>

                                              <p className={'m-0'}>
                                                <b>Due Date:</b> {formatDate(item?.dueDate)}
                                              </p>
                                              {item?.invoiceGroup && <>
                                                <p className={'m-0'}>
                                                  <b>Amount Due:</b> {formatCurrency(item.amountDue)}
                                                </p>
                                              </>}

                                              {item?.invoices?.length > 0 && <p className={'m-0'}>
                                                <b>Items:</b>
                                              </p>}
                                              {item?.invoices?.sort((a, b) => a.amountDue - b.amountDue).map((inv, idx) => {
                                                return <span key={idx} className={'d-block'} style={{
                                                  paddingLeft: '8px',
                                                  marginLeft: '6px',
                                                  marginBottom: '2px',
                                                  borderLeft: 'solid 2px #efefef'
                                                }}>
                                                  <InvoiceItem item={inv} group={true}/>
                                                </span>
                                              })
                                              }
                                            </>}
                                            {!item?.invoiceGroup && <>
                                              <InvoiceItem item={item}/>
                                            </>
                                            }
                                            {item.membershipInvoice && <>
                                              <Chip label={item.membershipName} icon={<Icon>loop</Icon>}
                                                    color="warning"/>
                                            </>
                                            }
                                          </Grid>
                                        </Grid>
                                      </div>
                                    )
                                  }
                                )}
                              </div>
                            </CardContent>
                          </Card>
                        </>
                      }


                      {client?.completedWaivers && client?.completedWaivers.length > 0 &&
                        <>
                          <Card className={'mt-4'}>
                            <CardContent>
                              <h5>
                                Signed Waivers & Contracts
                              </h5>
                              <Divider/>
                              <ul className={'list-group'}>
                                {client?.completedWaivers?.sort((a, b) => new Date(b.waiverDate).getTime() - new Date(a.waiverDate).getTime()).map((item, index) => {
                                    return (
                                      <li
                                        className={'list-group-item'}
                                        key={index}>
                                        <div className={'pull-right px-2'}
                                             onClick={(e) => {
                                               refHandler('downloadWaiver' + index)
                                             }}
                                             ref={el => (myRefs.current['downloadWaiver' + index] = el)}>

                                          <MDButton
                                            variant="outlined"
                                            color="secondary"
                                            size="small"
                                            circular
                                            iconOnly
                                          >
                                            <Icon>more_horiz</Icon>
                                          </MDButton>

                                          {renderIndex && myRefs.current['downloadWaiver' + index]?.visible &&
                                            <Menu open={true} anchorReference={null}
                                                  anchorEl={myRefs.current['downloadWaiver' + index]}
                                                  anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                  }}>
                                              <NotificationItem onClick={(e) => {
                                                viewWaiver(item)
                                              }} icon={<Icon>launch</Icon>} title="Preview"/>

                                              <NotificationItem onClick={(e) => {
                                                downloadWaiver(item)
                                              }} icon={<Icon>download</Icon>} title="Download"/>

                                            </Menu>
                                          }
                                        </div>
                                        {item.waiverName} - Completed on: {formatDate(item.waiverDate)}

                                        <br/> <Chip
                                        label={'Version: ' + item.version}
                                        variant="outlined"
                                        color="secondary"/>

                                      </li>
                                    )
                                  }
                                )}
                              </ul>
                            </CardContent>
                          </Card>
                        </>
                      }

                      <Card className={'mt-4'}>
                        <CardContent>
                          <h5>
                            Visit History {sysuserVisits?.length > 0 ? `(${sysuserVisits?.length})` : ''}
                          </h5>
                          <Divider/>
                          <ul className={'list-group'}>
                            {sysuserVisits?.length === 0 && <li className={'list-group-item'}>
                              <center>No recent visits</center>
                            </li>
                            }
                            {sysuserVisits.sort((a, b) => new Date(b.visitDate).getTime() - new Date(a.visitDate).getTime()).map((visit, index) => {
                                return (
                                  <li
                                    className={'list-group-item'}
                                    key={index}>
                                    {visit?.event?.inventory?.name || 'General Visit'}
                                    {visit?.attendee && <> {' (' + visit?.attendee?.firstName + ' ' + visit?.attendee?.lastName + ')'}</>}
                                    <br/>
                                    <small>{formatDateTime(visit.visitDate)}</small>
                                    {visit?.event?.waiver && <>
                                      <br/>
                                      <small>
                                        <a href="#" onClick={(e) => {
                                          e.preventDefault();
                                          viewWaiver(visit.event.waiver)
                                        }}>{visit?.event?.waiver.waiverName}</a> - Completed
                                        on: {formatDate(visit?.event?.waiver.waiverDate)}
                                        <a href="#" className="pull-right" onClick={(e) => {
                                          e.preventDefault();
                                          downloadWaiver(visit.event.waiver)
                                        }}><Icon>system_update_alt</Icon></a>

                                      </small>
                                    </>}
                                    <br/>
                                    <span>
                                      {visit?.noShow && <Chip label={'No Show'} className={'m-chip'}
                                                              color="warning"/>
                                      }
                                      {visit?.cancelled && <Chip label={'Cancelled'} className={'m-chip'}
                                                                 color="warning"/>
                                      }
                                      <Chip
                                        label={visit?.accountType?.name || 'General'} className={'m-chip'}
                                        variant="outlined"
                                        color="secondary"/>
                                    </span>


                                  </li>
                                )
                              }
                            )}
                          </ul>
                        </CardContent>
                      </Card>

                    </Col>
                    <Col sm={6} xs={12} className={'pt-4 py-md-0'}>

                      <Card className={'mb-4'}>
                        <CardContent>
                          {cafeMode && <>
                            <MDButton
                              color="secondary"
                              size="small"
                              sx={{
                                marginLeft: '5px'
                              }}
                              className={'pull-right'}
                              disabled={clientDisabled}
                              onClick={() => {
                                putClient(client);
                                toggleKioskMode('cafe');
                              }}>
                              <Icon>local_cafe</Icon>&nbsp;Cafe
                            </MDButton>
                          </>
                          }
                          <MDButton
                            color="secondary"
                            size="small"
                            sx={{
                              marginLeft: '5px'
                            }}
                            className={'pull-right'}
                            disabled={clientDisabled}
                            onClick={() => {
                              putClient(client);
                              toggleKioskMode('inventory');
                            }}>
                            <Icon>shopping_bag</Icon>&nbsp;Shop
                          </MDButton>

                          <MDButton
                            color="secondary"
                            size="small"
                            className={'pull-right mr-2'}
                            disabled={recordingVisit || clientDisabled || !(clientCart?.items?.length > 0)}
                            onClick={() => {
                              viewCustomerCart()
                            }}>
                            <span className={'fa fa-shopping-cart'}></span>&nbsp;View
                          </MDButton>
                          <h5>
                            Customer Cart
                          </h5>
                          <Divider/>
                          <ul className={'list-group'}>
                            {clientCart?.items?.length === 0 && <li className={'list-group-item'}>
                              <center>No cart items</center>
                            </li>
                            }

                            {clientCart?.items?.sort((a, b) => a.cartItemId - b.cartItemId).map((item, index) => {
                                return (
                                  <li
                                    className={'list-group-item'}
                                    key={index}>
                                    {toggleCartItems[item.cartItemId] && <>
                                      <Skeleton variant="rectangular" width={'100%'} height={25}/>
                                    </>}
                                    {!toggleCartItems[item.cartItemId] && <>
                                      <Avatar alt={item.inventoryItem?.name}
                                              className={'pull-left mr-3'}
                                              sx={{width: 32, height: 32}}>
                                        {item.inventoryItem?.imageUrl &&
                                          <img src={item.inventoryItem?.imageThumbUrl || item.inventoryItem?.imageUrl}
                                               style={{width: '200%', height: 'auto'}}
                                               alt={item.inventoryItem?.name}/>}
                                        {!item.inventoryItem?.imageUrl && item.inventoryItem.name.substring(0, 2)}
                                      </Avatar>
                                      &nbsp;{item.inventoryItem.name}
                                      <div className="pull-right" variant="outlined"
                                           size="small">
                                        <MDButton
                                          alt={'Delete Cart Item'}
                                          title={'Delete Cart Item'}
                                          className={'mx-1'}
                                          circular={true}
                                          iconOnly={true}
                                          color="primary"
                                          size="small"
                                          onClick={(e) => {
                                            preDeleteInventoryItem(item)
                                          }}>
                                          <span className={'fa fa-times'}></span>
                                        </MDButton>
                                        <MDButton
                                          alt={'Move to Tab'}
                                          title={'Move to Tab'}
                                          circular={true}
                                          iconOnly={true}
                                          color="secondary"
                                          size="small"
                                          onClick={(e) => {
                                            moveCartItemToTab(item)
                                          }}>
                                          <span className={'fa fa-clock'}></span>
                                        </MDButton>

                                      </div>
                                      <br/>
                                      <span
                                        className={'badge badge-primary bg-light-info text-black-50 fs--2'}>{item?.reservationStatus?.name}</span>

                                      {item.inventoryItem?.eventDate && <small>
                                        {formatDateTime(item.inventoryItem.eventDate, 'hh:mm a')} - {formatDateTime(item.inventoryItem.eventEndDate, 'hh:mm a')}
                                      </small>
                                      }
                                    </>}
                                  </li>
                                )
                              }
                            )}
                          </ul>
                        </CardContent>
                      </Card>

                      {clientTab?.items?.length > 0 && <div>
                        <Card className={'mb-4'}>
                          <CardContent>
                            <h5>
                              Customer Tab
                              <MDButton
                                alt={'Send to Checkout'}
                                title={'Send to Checkout'}
                                color="secondary"
                                size="small"
                                className={'pull-right mr-2'}
                                disabled={cartTabActive || recordingVisit || clientDisabled || !(clientTab?.items?.length > 0)}
                                onClick={() => {
                                  viewCustomerTab()
                                }}>
                                <span className={'fa fa-tag'}></span>&nbsp;Checkout
                              </MDButton>
                            </h5>

                            <ul className={'list-group'}>
                              {clientTab?.items?.sort((a, b) => a.cartItemId - b.cartItemId).map((item, index) => {
                                  return (
                                    <li
                                      className={'list-group-item'}
                                      key={index}>
                                      {toggleTabItems[item.cartItemId] && <>
                                        <Skeleton variant="rectangular" width={'100%'} height={25}/>
                                      </>}
                                      {!toggleTabItems[item.cartItemId] && <>

                                        <Avatar alt={item.inventoryItem?.name}
                                                className={'pull-left mr-3'}
                                                sx={{width: 32, height: 32}}>
                                          {item.inventoryItem?.imageUrl &&
                                            <img src={item.inventoryItem?.imageThumbUrl || item.inventoryItem?.imageUrl}
                                                 style={{width: '200%', height: 'auto'}}
                                                 alt={item.inventoryItem?.name}/>}
                                          {!item.inventoryItem?.imageUrl && item.inventoryItem.name.substring(0, 2)}
                                        </Avatar>
                                        &nbsp;{item.inventoryItem.name}

                                        <span className="pull-right" variant="outlined"
                                              size="small">
                                          <MDButton
                                            title={'Delete From Tab'}
                                            alt={'Delete From Tab'}
                                            className={'mx-1'}
                                            iconOnly={true}
                                            circular={true}
                                            color="primary"
                                            size="small"
                                            onClick={(e) => {
                                              preDeleteInventoryItem(item)
                                            }}>
                                            <span className={'fa fa-times'}></span>
                                          </MDButton>
                                          <MDButton
                                            title={'Move to Cart'}
                                            alt={'Move to Cart'}
                                            iconOnly={true}
                                            circular={true}
                                            color="secondary"
                                            size="small"
                                            onClick={(e) => {
                                              moveTabItemToCart(item)
                                            }}>
                                            <span className={'fa fa-cart-plus'}></span>
                                          </MDButton>

                                        </span>

                                        <br/>
                                        <span
                                          className={'badge badge-primary bg-light-info text-black-50 fs--2'}>{item?.reservationStatus?.name}</span>

                                        {item.inventoryItem?.eventDate && <small>
                                          {formatDateTime(item.inventoryItem.eventDate, 'hh:mm a')} - {formatDateTime(item.inventoryItem.eventEndDate, 'hh:mm a')}
                                        </small>
                                        }
                                      </>}
                                    </li>
                                  )
                                }
                              )}
                            </ul>
                          </CardContent>
                        </Card>
                      </div>}

                      {client?.favorites?.length > 0 && <>
                        <Card className={'mb-4'}>
                          <CardContent>
                            <h5>
                              Favorites
                            </h5>

                            <ul className={'list-group'}>
                              {client?.favorites?.map((favorite, idx) => {
                                return (
                                  <li className={'list-group-item'} key={idx}>
                                    <h6>{favorite.name}
                                      <span className={'pull-right'}>
                                       <FavoritesItemActions item={favorite}/>
                                     </span>
                                      {/*<MDButton size={'small'} color={'primary'} className={'pull-right'}>*/}
                                      {/*   Reorder*/}
                                      {/* </MDButton>*/}
                                    </h6>
                                    <Grid container>
                                      <Grid item xs={3}>
                                        <Avatar alt={favorite?.name}
                                                className={'m-2 '}
                                                variant="rounded"
                                                sx={{width: '80%', height: 'auto', background: '#fff'}}
                                                src={favorite?.imageUrl}
                                        >
                                        </Avatar>
                                        &nbsp;
                                      </Grid>
                                      <Grid item xs={9}>
                                        {favorite?.cafeOptions?.sort((a, b) => a.sortOrder - b.sortOrder).map((option, optionIdx) => {
                                          return (
                                            <CafeOrderOptionItem key={optionIdx} option={option}/>
                                          )
                                        })}
                                      </Grid>
                                    </Grid>
                                  </li>
                                )
                              })
                              }
                            </ul>
                          </CardContent>
                        </Card>
                      </>}

                      <Card className={'mb-4'}>
                        <CardContent>
                          <MDButton
                            color="secondary"
                            size="small"
                            className={'pull-right'}
                            disabled={recordingVisit || clientDisabled}
                            onClick={toggleLookupEventsFn}>
                            {!recordingVisit ? <><span className={'fa fa-calendar'}></span>&nbsp;Book New</>
                              : <><span className={'fa fa-spinner fa-spin'}></span>&nbsp;Recording</>}
                          </MDButton>
                          <h5>
                            Upcoming Reservations
                          </h5>
                          <Divider/>
                          <ul className={'list-group'}>
                            {reservations?.length === 0 && <li className={'list-group-item'}>
                              <center>No upcoming reservations</center>
                            </li>
                            }
                            {reservations?.length > 0 && reservations?.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime()).map((reservation, index) => {
                                return (
                                  <li
                                    className={'list-group-item'}
                                    key={index}>
                                    {reservation?.cancelling && <span className={'fa fa-spinner fa-spin'}></span>}
                                    <Link to={'/event/view/' + reservation.eventGuid}>
                                      {reservation.eventName}
                                      {reservation?.attendee &&
                                        <> {' (' + reservation?.attendee.firstName + ' ' + reservation?.attendee.lastName + ')'}</>
                                      }
                                    </Link>
                                    <span className={'pull-right'}
                                          ref={el => (myRefs.current['reservationsActions-' + index] = el)}
                                          onClick={(e) => {
                                            refHandler('reservationsActions-' + index)
                                          }}>

                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>
                                      {renderIndex && myRefs.current['reservationsActions-' + index]?.visible &&
                                        <Menu open={true} anchorReference={null}
                                              anchorEl={myRefs.current['reservationsActions-' + index]}
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                              }}>

                                          {reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN &&
                                            <NotificationItem
                                              disabled={reservation.cancelling}
                                              onClick={(e) => {
                                                undoCheckinFn(reservation)
                                              }} icon={<Icon>history</Icon>} title="Undo Check-In"/>
                                          }

                                          <NotificationItem
                                            onClick={(e) => {
                                              startMoveReservation(reservation)
                                            }} icon={<Icon>forward</Icon>} title="Move Reservation"/>

                                          <NotificationItem
                                            disabled={reservation.cancelling}
                                            onClick={(e) => {
                                              cancelReservationFn(reservation)
                                            }} icon={<Icon>cancel</Icon>} title="Cancel Reservation"/>

                                          <NotificationItem
                                            disabled={reservation.cancelling}
                                            onClick={(e) => {
                                              noShowReservationFn(reservation)
                                            }} icon={<Icon>event_busy</Icon>} title="No-Show"/>


                                        </Menu>
                                      }
                                    </span>

                                    <br/>

                                    <span style={{
                                      'clear': 'both',
                                      'display': 'block',
                                      'marginTop': '10px'
                                    }}>

                                      <MDButton
                                        color="info"
                                        size="small"
                                        className="pull-right"
                                        disabled={recordingVisit || reservationDisabled(reservation) || clientDisabled}
                                        onClick={(e) => {
                                          recordVisitFn(e, reservation);
                                        }}>
                                       {reservationDisabled(reservation) && reservation?.reservationStatus?.name}

                                        {!reservationDisabled(reservation) && <>
                                          {reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.WALKIN_WAIVER && <>
                                          <span
                                            className={'fa fa-cart-plus'}></span>&nbsp;Complete Reservation
                                          </>
                                          }
                                          {reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.WALKIN_WAIVER && <>
                                            {reservation?.saving ? <span
                                              className={'fa fa-spinner fa-spin'}></span> : <span
                                              className={'fa fa-check'}></span>}
                                            &nbsp;Check{reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN ? 'ed' : ''}&nbsp;In
                                          </>
                                          }
                                        </>
                                        }
                                      </MDButton>

                                      <Chip
                                        label={reservation?.reservationStatus?.name}
                                        variant="outlined"
                                        color="secondary"/>

                                    </span>

                                    {reservation?.waiver && <>
                                      <div className={'d-block mt-2'}>
                                        <small>
                                          <a href="#" onClick={(e) => {
                                            e.preventDefault();
                                            viewWaiver(reservation.waiver)
                                          }}>{reservation?.waiver.waiverName}</a> - Completed
                                          on: {formatDate(reservation?.waiver.waiverDate)}
                                          <a href="#" className="pull-right" onClick={(e) => {
                                            e.preventDefault();
                                            downloadWaiver(reservation.waiver)
                                          }}><Icon>system_update_alt</Icon></a>

                                        </small>
                                      </div>
                                    </>}

                                    <ReservationAddons reservation={reservation}/>

                                  </li>
                                )
                              }
                            )}
                          </ul>
                        </CardContent>
                      </Card>

                      <Card>
                        <CardContent>
                          <MDButton
                            color="secondary"
                            size="small"
                            disabled={clientDisabled}
                            className={'pull-right'}
                            onClick={(e) => {
                              e.preventDefault();
                              manageFamilyMemberFn(null)
                            }}>
                            <span className={'fa fa-user-plus'}></span>&nbsp;Add
                          </MDButton>

                          <h5>
                            Family Members
                          </h5>
                          <Divider/>
                          <Row>
                            <Col sm={12}>
                              <ul className={'list-group'}>
                                {client?.familyMembers?.length === 0 && <li className={'list-group-item'}>
                                  <center>No family members</center>
                                </li>
                                }
                                {renderIndex && client?.familyMembers
                                  .sort((a, b) => a.id > b.id ? 1 : -1)
                                  .map((familyMember, index) => {
                                    return (<li className={'list-group-item'}
                                                style={{
                                                  'position': 'relative',
                                                }}
                                                key={index}>
                                  <span className={'cursor-pointer'} onClick={(e) => {
                                    manageFamilyMemberFn(familyMember)
                                  }}>
                                    {familyMember?.notes?.length > 0 &&
                                      <Icon
                                        style={{
                                          marginTop: '4px',
                                          float: 'left',
                                          width: '15px',
                                          height: '15px'
                                        }}>bookmarks</Icon>
                                    }
                                    {familyMember.firstName} {familyMember.lastName}
                                    <span className={'font-smaller'}>
                                      {familyMember?.dob && ' (' + formatAge(familyMember) + ')'}
                                    </span>
                                  </span>

                                      <div className={'pull-right px-2'}
                                           onClick={(e) => {
                                             refHandler('familyMember' + index)
                                           }}
                                           ref={el => (myRefs.current['familyMember' + index] = el)}>

                                        <MDButton
                                          variant="outlined"
                                          color="secondary"
                                          size="small"
                                          circular
                                          iconOnly
                                        >
                                          <Icon>more_horiz</Icon>
                                        </MDButton>

                                        {renderIndex && myRefs.current['familyMember' + index]?.visible &&
                                          <Menu open={true} anchorReference={null}
                                                anchorEl={myRefs.current['familyMember' + index]}
                                                anchorOrigin={{
                                                  vertical: "bottom",
                                                  horizontal: "left",
                                                }}>
                                            <NotificationItem
                                              disabled={clientDisabled}
                                              onClick={(e) => {
                                                viewFamilyMemberFn(familyMember)
                                              }} icon={<Icon>notes</Icon>} title="Notes"/>

                                            <NotificationItem
                                              disabled={clientDisabled}
                                              onClick={(e) => {
                                                manageFamilyMemberFn(familyMember)
                                              }} icon={<Icon>edit</Icon>} title="Edit"/>
                                            <NotificationItem
                                              disabled={clientDisabled}
                                              onClick={(e) => {
                                                preDeleteFamilyMemberFn(familyMember)
                                              }} icon={<Icon>delete</Icon>} title="Delete"/>
                                          </Menu>
                                        }
                                      </div>
                                      <br/>
                                      <Chip
                                        color="secondary"
                                        variant="outlined"
                                        label={familyMember.familyMemberType.name}/>&nbsp;
                                      {familyMember.emergencyContact &&
                                        <Chip
                                          color="secondary"
                                          variant="outlined"
                                          label={'Emergency Contact ' + displayPhone(familyMember.phoneNumber)}/>
                                      }
                                      {familyMember?.notes?.length > 0 && familyMember?.notes?.sort((a, b) => a.createDate - b.createDate).map((a, idx) => {
                                        if (a.pinned) {
                                          return (
                                            <span key={idx}>
                                              <Chip
                                                color="secondary"
                                                variant="outlined"
                                                label={a.note}/>
                                              &nbsp;</span>
                                          )
                                        }
                                      })}
                                    </li>);
                                  })}
                              </ul>
                            </Col>
                          </Row>
                        </CardContent>
                      </Card>

                      <Card className={'mt-4'}>
                        <CardContent>
                          <MDButton
                            color="secondary"
                            size="small"
                            disabled={clientDisabled}
                            className={'pull-right'}
                            onClick={(e) => {
                              // addMembershipFn();
                              putClient(client);
                              toggleKioskMode('memberships');
                            }}>
                            <span className={'fa fa-user-plus'}></span>&nbsp;Add Membership
                          </MDButton>

                          <h5>
                            Memberships
                          </h5>
                          <Divider/>
                          <Row>
                            <Col sm={12}>

                              <ButtonGroup className={'mb-2'}
                                           variant="outlined"
                                           size="small"
                                           aria-label="Memberships">

                                <Button
                                  size="small"
                                  key={'active'}
                                  style={{
                                    color: membershipTabActive === 'active' ? '#fff' : '#111',
                                    background: membershipTabActive === 'active' ? '#111' : '#fff',
                                    borderColor: '#111'
                                  }}
                                  onClick={(e) => {
                                    setMembershipTabActive('active')
                                  }}>
                                  Active {client?.accounts?.length > 0 && `(${client?.accounts?.length})`}
                                </Button>
                                <Button
                                  size="small"
                                  style={{
                                    color: membershipTabActive === 'expired' ? '#fff' : '#111',
                                    background: membershipTabActive === 'expired' ? '#111' : '#fff',
                                    borderColor: '#111'
                                  }}
                                  key={'expired'}
                                  onClick={(e) => {
                                    setMembershipTabActive('expired')
                                  }}>
                                  Inactive {client?.expiredAccounts?.length > 0 && `(${client?.expiredAccounts?.length})`}
                                </Button>

                              </ButtonGroup>
                              {membershipTabActive === 'expired' && <>
                                <ul className={'list-group'}>
                                  {client?.expiredAccounts?.length === 0 && <li className={'list-group-item'}>
                                    <center>No past memberships</center>
                                  </li>
                                  }
                                  {renderIndex && client?.expiredAccounts
                                    .sort((a, b) => a.accountId > b.accountId ? 1 : -1)
                                    .map((account, index) => {
                                      return (<li className={'list-group-item'}
                                                  style={{
                                                    'position': 'relative',
                                                  }}
                                                  key={index}>
                                  <span>{account.name}
                                    <br/>
                                    <small>{account.accountType?.name} {account?.recurring &&
                                      <span alt={"Recurring"} title={"Recurring"}><LoopIcon/></span>}</small>
<div className={'pull-right px-2'}
     onClick={(e) => {
       refHandler('inactiveMemberAccount' + index)
     }}
     ref={el => (myRefs.current['inactiveMemberAccount' + index] = el)}>

                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>

  {renderIndex && myRefs.current['inactiveMemberAccount' + index]?.visible &&
    <Menu open={true} anchorReference={null}
          anchorEl={myRefs.current['inactiveMemberAccount' + index]}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}>
      <NotificationItem
        onClick={(e) => {
          let _account = {...account}
          _account.reEnable = true;
          setMemberAccount(_account);

          setConfirmReactivateAccount(true);

          let confirmation = {
            title: 'Re-activate Membership',
            message: 'Confirm re-activate ' + _account.name,
            entity: _account
          }

          setConfirmation(confirmation);

        }} icon={<Icon>edit</Icon>} title="Re-Activate"/>

    </Menu>
  }
                                      </div>
                                    <br/>
                                    {account.billingEndDate && <><Chip className={'mb-2'}
                                                                       color="secondary"
                                                                       variant="outlined"
                                                                       label={(account?.timeBased ? 'Membership' : 'Billing') + ' End Date: ' + (formatDate(account.billingEndDate))}
                                    />&nbsp;</>}

                                    <Chip className={'mb-2'}
                                          color="secondary"
                                          variant="outlined"
                                          label={'Created on: ' + (formatDate(account.createDate))}
                                    />&nbsp;
                                    {orgAccess?.ready && <>
                                      <Chip className={'mb-2'}
                                            color="info"
                                            label={account?.companyName}/>&nbsp;
                                    </>
                                    }
                                    <Chip className={'mb-2'}
                                          color="secondary"
                                          variant="outlined"
                                          label={'Remaining Visits: ' + (account?.accountType?.unlimitedVisits ? 'Unlimited' : account?.numberVisits)}
                                    />&nbsp;
                                    {account?.pendingCancellation && <>

                                      {account?.cancelReason && <>

                                        <OverlayTrigger
                                          placement={'top'}
                                          delay={{show: 250, hide: 400}}
                                          overlay={
                                            <Tooltip>
                                              {account.cancelReason}
                                            </Tooltip>
                                          }>
                                          <Chip className={'mb-2'} sx={{
                                            marginRight: '4px',
                                            cursor: 'pointer'
                                          }}
                                                color="warning"
                                                icon={<Icon>info</Icon>}
                                                variant="outlined"
                                                label={<>Cancellation Scheduled
                                                  <b> {formatDate(getNextBillingDate(account))}</b></>}
                                          />
                                        </OverlayTrigger>
                                      </>}

                                      {!account?.cancelReason && <>
                                        <Chip className={'mb-2'}
                                              color="warning"
                                              variant="outlined"
                                              label={<>Cancellation Scheduled
                                                <b> {formatDate(getNextBillingDate(account))}</b></>}
                                        />&nbsp;
                                      </>
                                      }

                                    </>
                                    }

                                    <Audit auditModifyUser={account} auditCreateUser={account}/>
                                  </span>
                                      </li>);
                                    })}
                                </ul>
                              </>}
                              {membershipTabActive === 'active' && <>
                                <ul className={'list-group'}>
                                  {client?.accounts?.length === 0 && <li className={'list-group-item'}>
                                    <center>No memberships</center>
                                  </li>
                                  }
                                  {renderIndex && client?.accounts
                                    .sort((a, b) => a.accountId > b.accountId ? 1 : -1)
                                    .map((account, index) => {
                                      return (<li className={'list-group-item'}
                                                  style={{
                                                    'position': 'relative',
                                                  }}
                                                  key={index}>
                                  <span>
                                    {account?.accountAccess?.length == 0 && <>
                                      <Link to={'#'} onClick={(e) => {
                                        e.preventDefault();
                                        manageMemberAccountFn(account)
                                      }}>
                                        {account.name}
                                      </Link>
                                    </>}
                                    {account?.accountAccess?.length > 0 && <>
                                      <OverlayTrigger
                                        placement={'bottom'}
                                        delay={{show: 250, hide: 400}}
                                        overlay={
                                          <Tooltip>
                                            <div style={{
                                              textAlign: 'left'
                                            }}>
                                              <b>Event Type Access:</b> {displayAccountAccess(account.accountAccess)}
                                            </div>
                                          </Tooltip>
                                        }>
                                    <span>
                                      <Link to={'#'} onClick={(e) => {
                                        e.preventDefault();
                                        manageMemberAccountFn(account)
                                      }}>
                                        {account.name}
                                      </Link>
                                    </span>
                                      </OverlayTrigger>
                                    </>}
                                    <br/>
                                    <small>{account.accountType?.name}</small>
                                    <div className={'pull-right px-2'}
                                         onClick={(e) => {
                                           refHandler('memberAccount' + index)
                                         }}
                                         ref={el => (myRefs.current['memberAccount' + index] = el)}>

                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>

                                      {renderIndex && myRefs.current['memberAccount' + index]?.visible &&
                                        <Menu open={true} anchorReference={null}
                                              anchorEl={myRefs.current['memberAccount' + index]}
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "left",
                                              }}>
                                          <NotificationItem
                                            onClick={(e) => {
                                              manageMemberAccountFn(account)
                                            }} icon={<Icon>edit</Icon>} title="Edit"
                                            placement={'left'}
                                            tip={"Add or modify a future end date, or adjust the number of included day passes."}/>

                                          {account?.accountType?.lockedAccount &&
                                            <NotificationItem
                                              onClick={(e) => {
                                                startManageAccountMembers(account)
                                              }} icon={<Icon>group</Icon>} title="Manage Members"
                                              placement={'left'}
                                              tip={"Update the membership members."}/>
                                          }
                                          {account.accountType.recurring && <NotificationItem
                                            onClick={(e) => {
                                              manageAccountStartDateFn(account)
                                            }} icon={<Icon>edit_calendar</Icon>} title="Change Start Date"
                                            placement={'left'}
                                            tip={"Update the membership start date."}/>}

                                          <NotificationItem onClick={(e) => {
                                            preCancelMembershipFn(account)
                                          }} icon={<Icon>credit_card_off</Icon>} title="Cancel Membership"
                                                            placement={'left'}
                                                            tip={"Membership remains active until the end of the current billing cycle."}/>

                                          <NotificationItem onClick={(e) => {
                                            preDeleteMembershipFn(account)
                                          }} icon={<Icon>delete</Icon>} title="Delete Membership"
                                                            placement={'left'}
                                                            tip={"Membership is terminated immediately."}/>
                                        </Menu>
                                      }
                                      </div>
                                    <br/>

                                    {account?.recurring &&
                                      <><Chip className={'mb-2'}
                                              color="secondary"
                                              variant="outlined"
                                              icon={<LoopIcon/>}
                                              label={'Recurs ' + account.recurDefinition.toLowerCase() + ' at ' + formatCurrency(account?.accountPrice)}
                                      />&nbsp;
                                      </>
                                    }

                                    {account.billingEndDate && <><Chip className={'mb-2'}
                                                                       color="warning"
                                                                       label={(account?.timeBased ? 'Membership' : 'Billing') + ' End Date: ' + (formatDate(getDateNoTz(account.billingEndDate)))}
                                    />&nbsp;</>}
                                    <Chip className={'mb-2'}
                                          color="secondary"
                                          variant="outlined"
                                          label={'Created on: ' + (formatDate(account.createDate))}
                                    />&nbsp;
                                    <Chip className={'mb-2'}
                                          color="secondary"
                                          variant="outlined"
                                          label={'Remaining Visits: ' + (account?.accountType?.unlimitedVisits ? 'Unlimited' : account?.numberVisits)}
                                    />&nbsp;

                                    {account?.displayAccessUsers?.length > 0 && <>
                                      <Chip onClick={(e) => {
                                        startManageAccountMembers(account);
                                      }}
                                            className={'mb-2'}
                                            color="primary"
                                            label={'Members: ' + (account?.displayAccessUsers.join(', '))}
                                      />&nbsp;
                                    </>}
                                    {account?.pendingCancellation && <>

                                      {account?.cancelReason && <>

                                        <OverlayTrigger
                                          placement={'top'}
                                          delay={{show: 250, hide: 400}}
                                          overlay={
                                            <Tooltip>
                                              {account.cancelReason}
                                            </Tooltip>
                                          }>
                                          <Chip className={'mb-2'} sx={{
                                            marginRight: '4px',
                                            cursor: 'pointer'
                                          }}
                                                color="warning"
                                                icon={<Icon>info</Icon>}
                                                variant="outlined"
                                                label={<>Cancellation Scheduled
                                                  <b> {formatDate(getNextBillingDate(account))}</b></>}
                                          />
                                        </OverlayTrigger>
                                      </>}

                                      {!account?.cancelReason && <>
                                        <Chip className={'mb-2'}
                                              color="warning"
                                              variant="outlined"
                                              label={<>Cancellation Scheduled
                                                <b> {formatDate(getNextBillingDate(account))}</b></>}
                                        />&nbsp;
                                      </>
                                      }

                                    </>
                                    }


                                    {orgAccess?.ready && <>
                                      <Chip className={'mb-2'}
                                            color="info"
                                            label={account?.companyName}/>&nbsp;
                                    </>
                                    }

                                    {nextBillingDate(account) && <><Chip className={'mb-2'}
                                                                         color="secondary"
                                                                         variant="outlined"
                                                                         label={'Next Billing Date: ' + formatDate(account.nextBillDate)}
                                    />&nbsp;</>}
                                    {account?.minimumMembership && <><Chip
                                      className={'pull-left m-chip'}
                                      icon={<Icon>lock_clock</Icon>}
                                      label={<>Mininum
                                        Commitment {account?.minMembershipMonths} {account?.minMembershipMonths === 1 ? 'Month' : 'Months'}.
                                        {account?.minimumCancellationDate && new Date(account?.minimumCancellationDate).getTime() > new Date().getTime() && <>
                                          Commitment ends {formatDate(account?.minimumCancellationDate)}</>}
                                      </>}
                                      variant="outlined"
                                    />&nbsp;</>}

                                    {account?.minimumCancellation && <><Chip
                                      className={'pull-left m-chip'}
                                      icon={<Icon>lock_person</Icon>}
                                      label={<>Mininum
                                        Cancellation
                                        Notice {account?.minimumCancellationDays} {account?.minimumCancellationDays === 1 ? 'Day' : 'Days'}</>}
                                      variant="outlined"
                                    />&nbsp;</>}

                                    {account?.futureMembership && <><Chip className={'mb-2'}
                                                                          color="success"
                                                                          label={'Membership Start Date: ' + formatDate(account.membershipStartDate)}
                                    />&nbsp;</>}

                                  </span>
                                      </li>);
                                    })}
                                </ul>
                              </>
                              }


                            </Col>
                          </Row>
                        </CardContent>
                      </Card>

                      <Card className={'mt-4'}>
                        <CardContent>
                          {saleHistoryIndex > 0 && <CustomerSaleGroupHistory customer={client}
                                                                             viewAll={fullSalesHistory}
                                                                             memberCallback={() => {
                                                                               setRefreshMember(true);
                                                                             }}
                                                                             callback={() => {
                                                                               setSaleHistoryIndex(saleHistoryIndex + 1)
                                                                             }}
                                                                             saleHistoryIndex={saleHistoryIndex}
                                                                             modalActive={() => {
                                                                               setModalActive(true);
                                                                             }}
                                                                             modalInactive={() => {
                                                                               setModalActive(false);
                                                                             }}/>}
                          {/*{saleHistoryIndex > 0 && <CustomerSaleHistory*/}
                          {/*  customer={client}*/}
                          {/*  viewAll={fullSalesHistory}*/}
                          {/*  callback={() => {*/}
                          {/*    setSaleHistoryIndex(saleHistoryIndex + 1)*/}
                          {/*  }}*/}
                          {/*  saleHistoryIndex={saleHistoryIndex}*/}
                          {/*  modalActive={() => {*/}
                          {/*    setModalActive(true);*/}
                          {/*  }}*/}
                          {/*  modalInactive={() => {*/}
                          {/*    setModalActive(false);*/}
                          {/*  }}*/}
                          {/*/>}*/}
                        </CardContent>
                      </Card>

                    </Col>
                  </Row>

                  <Card className={'mt-4'}>
                    <CardContent>
                      <h5>
                        Customer Notes
                        <MDButton
                          color="secondary"
                          size="small"
                          disabled={clientDisabled}
                          className={'pull-right'}
                          onClick={addNoteFn}>
                          <span className={'fa fa-plus'}></span>&nbsp;Add note
                        </MDButton>
                        <input type={'text'}
                               className={'form-control form-control-sm my-n1 mx-2 pull-right w-25'}
                               placeholder={'Search Notes'}
                               onFocus={(e) => {
                                 setModalActive(true);
                               }}
                               onBlur={(e) => {
                                 setModalActive(false);
                               }}
                               onChange={(e) => {
                                 setSearchNotes(e.target.value);
                               }}/>
                      </h5>
                      <Divider/>
                      <Row style={{
                        'clear': 'both',
                        'maxHeight': '500px',
                        'overflow': 'auto'
                      }} ref={notesRef}>
                        <Col sm={12}>

                          <ul className={'list-group'}>
                            {clientNotes?.length === 0 && <li className={'list-group-item'}>
                              <center>No customer notes</center>
                            </li>
                            }

                            {clientNotes?.sort((a, b) => a.createDate - b.createDate).filter((a) => a.pinned).map((note, index) => {
                                return (
                                  <NoteItem note={note} key={index} index={index}/>
                                )
                              }
                            )}

                            {clientNotes?.sort((a, b) => a.createDate - b.createDate).filter((a) => !!!a.pinned).map((note, index) => {
                                return (
                                  <NoteItem note={note} key={index} index={index}/>
                                )
                              }
                            )}

                          </ul>

                        </Col>
                      </Row>
                    </CardContent>
                  </Card>

                </Col>

              </Row>
            </>
            }

            {
              newCustomer && <>
                <ManageClientModal
                  customer={null}
                  show={onEdit}
                  saving={saving}
                  handleSaveCustomer={handleSaveCustomer}
                  handleClose={handleClose}/>
              </>
            }

            {
              client?.guid && <>
                <ManageClientModal
                  customer={newCustomer ? null : client}
                  show={onEdit}
                  saving={saving}
                  handleSaveCustomer={handleSaveCustomer}
                  handleClose={handleClose}/>


                {manageFamilyMember && <ManageFamilyMemberModal
                  familyMember={familyMember}
                  show={manageFamilyMember}
                  saving={saving}
                  handleSaveFamilyMember={handleSaveFamilyMember}
                  handleCloseFamilyMember={handleCloseFamilyMember}/>
                }

                {viewFamilyMemberNotes && <ViewFamilyMemberNotesModal
                  familyMember={familyMember}
                  show={viewFamilyMemberNotes}
                  saving={saving}
                  handleSaveFamilyMember={() => {
                    setViewFamilyMemberNotes(false)
                  }}
                  handleCloseFamilyMember={() => {
                    setViewFamilyMemberNotes(false)
                  }}/>
                }


              </>
            }
            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeleteFamilyMember}
                                       saving={saving}
                                       handleConfirm={handleConfirmFamilyMember}
                                       handleSave={handleCancelFamilyMember}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmReactivateAccount}
                                       saving={saving}
                                       handleConfirm={() => {
                                         handleSaveMemberAccount(memberAccount);
                                         setConfirmation(null);
                                         setConfirmReactivateAccount(false);
                                       }}
                                       handleSave={() => {
                                         setConfirmation(null);
                                         setConfirmReactivateAccount(false);
                                       }}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeleteNote}
                                       saving={saving}
                                       handleConfirm={handleConfirmDeleteNote}
                                       handleSave={() => {
                                         setConfirmation(null);
                                         setConfirmDeleteNote(false);
                                       }}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmCancelMembership}
                                       saving={saving}
                                       handleConfirm={handleCancelMembership}
                                       handleSave={() => {
                                         setConfirmation(null);
                                         setConfirmCancelMembership(false);
                                       }}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeleteMembership}
                                       saving={saving}
                                       handleConfirm={handleConfirmMembership}
                                       handleSave={() => {
                                         setConfirmation(null);
                                         setConfirmDeleteMembership(false);
                                       }}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeleteMember}
                                       saving={saving}
                                       handleConfirm={handleConfirmMember}
                                       handleSave={handleCancelMember}/>
            }
            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeleteBilling}
                                       saving={saving}
                                       handleConfirm={handleConfirmDeleteBilling}
                                       handleSave={handleCancelDeleteBilling}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeleteInvoice}
                                       saving={saving}
                                       handleConfirm={handleConfirmDeleteInvoice}
                                       handleSave={handleCancelDeleteInvoice}/>
            }

            {
              manageClientBilling && <ManageClientBillingModal
                clientBilling={clientBilling}
                show={manageClientBilling}
                saving={saving}
                handleSaveClientBilling={handleSaveClientBilling}
                handleCloseClientBilling={handleCloseClientBilling}/>
            }

            {
              memberAccount && <ManageAccountModal
                key={memberAccount?.account?.guid}
                account={memberAccount}
                billingEndDate={memberAccount?.billingEndDate}
                show={manageMemberAccount}
                saving={saving}
                handleSave={handleSaveMemberAccount}
                handleClose={handleCloseManageAccount}/>
            }

            {
              manageAccountStartDate && <ManageAccountStartDateModal
                key={memberAccount?.account?.guid}
                account={memberAccount}
                startDate={memberAccount?.startDate}
                show={manageAccountStartDate}
                saving={saving}
                handleSave={handleSaveAccountStartDate}
                handleClose={() => {
                  setMemberAccount(null);
                  setManageAccountStartDate(false);
                }}/>
            }

            {addPerk && <ClientAssignPerk
              show={addPerk}
              client={client}
              handleSave={() => {
                setRefreshMember(true);
                toggleAddPerkFn();
              }}
              handleClose={() => {
                toggleAddPerkFn();
              }}
            />}

            {changeLocation && <ClientChangeLocation
              show={changeLocation}
              client={client}
              handleSave={() => {
                setRefreshMember(true);
                setChangeLocation(false)
              }}
              handleClose={() => {
                setChangeLocation(false)
              }}
            />}

            {showFlags && <NoteFlagsModal
              notes={clientNotes}
              show={showFlags}
              handleClose={() => {
                setShowFlags(false)
              }}
            />}

            {
              manageInvoice && <ClientManageInvoiceModal
                invoice={invoice}
                show={manageInvoice}
                saving={saving}
                handleClose={(e) => {
                  setManageInvoice(false);
                  setInvoice(null);
                }}
                handleRefresh={(invoice) => {
                  handleRefreshInvoice(invoice);
                }}
                handleSave={(d) => {
                  setManageInvoice(false);
                  setInvoice(null);
                  setRefreshMember(true)
                }}/>
            }

            {
              confirmMergeInvoices && <ClientMergeInvoices
                invoices={invoicesToMerge}
                invoiceGroups={invoiceGroupsToMerge}
                show={confirmMergeInvoices}
                saving={saving}
                handleClose={(e) => {
                  setConfirmMergeInvoices(false);
                }}
                handleSave={(data) => {
                  setSaving(true);
                  handleSaveMergeInvoices(data);
                }}/>
            }


            {
              composeSms && <ComposeSms
                key={client?.guid}
                client={client}
                show={composeSms}
                handleClose={() => {
                  setComposeSms(false)
                }}
                handleSave={() => {
                  setComposeSms(false);
                }}/>
            }

            {
              (addNote || manageClientNote) && <ClientNoteModal
                key={clientNote?.guid}
                note={clientNote}
                show={manageClientNote || addNote}
                saving={saving}
                handleClose={handleCloseNote}
                handleSave={handleSaveClientNote}/>
            }


            {
              lookupEvents && <ClientLookupEventsModal
                show={true}
                hideDesc={true}
                client={client}
                saving={saving}
                handleClose={toggleLookupEventsFn}
                handleSave={handleSaveEvent}/>
            }

            {
              lookupMemberships && <ClientLookupMembershipsModal
                show={true}
                client={client}
                saving={saving}
                handleClose={toggleLookupMembershipsFn}
                handleSave={handleSaveMembership}/>
            }

            {
              isManageMemberAccount && <ClientManageAccountMembers
                show={isManageMemberAccount}
                accountMembership={accountMembership}
                client={client}
                handleClose={() => {
                  setIsManageMemberAccount(false);
                  setAccountMembership(null);
                }}
                handleSave={handleSaveMembershipAccount}/>
            }

            {
              cartActive && <CartFinal
                client={client}
                invoice={invoice}
                cartActive={cartActive}
                callback={cartCallback}
              />
            }

            {showInventoryModal && <ViewInventoryModal
              handleClose={() => {
                setShowInventoryModal(false);
              }}
              handleSave={(item) => {
                sendToCartFn(item);
                setShowInventoryModal(false);
              }}
              client={client}
              show={showInventoryModal}
              inventory={inventory}
            />}

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={showConfirm}
                                       saving={saving}
                                       handleSave={() => {
                                         setShowConfirm(false);
                                       }}
                                       handleConfirm={deleteInventoryItem}
                                       handleClose={handleCancelCartRemove}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmDeletePerk}
                                       saving={saving}
                                       handleConfirm={() => {
                                         removePerkFn(confirmation?.entity)
                                       }}
                                       handleSave={() => {
                                         setConfirmation(null);
                                         setConfirmDeletePerk(false);
                                       }}/>
            }

            {
              confirmation && <Confirm confirmation={confirmation}
                                       show={confirmInvoiceReminder}
                                       saving={saving}
                                       handleConfirm={() => {
                                         sendInvoiceReminder(invoice);
                                       }}
                                       handleSave={() => {
                                         setConfirmation(null);
                                         setConfirmInvoiceReminder(false);
                                       }}/>
            }

            {showRegisterEvent && <RegisterEventModal
              handleClose={() => {
                setShowRegisterEvent(false)
              }}
              successCallback={() => {
                setShowRegisterEvent(false);
                viewCustomerCart();
              }}
              client={client}
              show={showRegisterEvent}
              event={inventoryEvent}
            />
            }
            {addPayment && <SquareAddPayment
              client={client}
              show={addPayment}
              handleClose={(e) => {
                setAddPayment(false);
                setRefreshMember(true);
              }}/>}

            {convertInvoice && invoice && <ConvertInvoiceModal invoice={invoice}
                                                               key={invoice?.invoiceGuid}
                                                               show={convertInvoice}
                                                               handleSave={() => {
                                                                 setInvoice(null);
                                                                 setConvertInvoice(false)
                                                                 setRefreshMember(true);
                                                               }}
                                                               handleClose={() => {
                                                                 setInvoice(null);
                                                                 setConvertInvoice(false)
                                                               }}

            />}


            {previewInvoice && <ViewInvoiceModal invoice={invoice}
                                                 key={invoice?.invoiceGuid}
                                                 show={previewInvoice}
                                                 handleClose={() => {
                                                   setInvoice(null);
                                                   setPreviewInvoice(false)
                                                 }}

            />}
            {showPreview &&
              <Preview previewContent={waiverPreview?.waiverBody}
                       previewTitle={waiverPreview?.waiverName}
                       showPreview={showPreview}
                       handleClose={() => {
                         setShowPreview(false);
                       }}/>
            }

            {showGiftCardQR && <GiftCardQrCode show={showGiftCardQR}
                                               giftCard={giftCardQrCode}
                                               handleClose={(args) => {
                                                 if ('refresh' === args) {
                                                   setRefreshMember(true);
                                                 }
                                                 setGiftCardQrCode(null);
                                                 setShowGiftCardQR(false);
                                               }}
            />}

            {redeemGiftCard &&
              <CustomerRedeemGiftCard client={client} show={redeemGiftCard}
                                      handleClose={() => {
                                        setRedeemGiftCard(false)
                                      }}
                                      handleSave={() => {
                                        setRedeemGiftCard(false)
                                        setRefreshMember(true);
                                      }}
              />
            }
            {
              showMoveRegistration && reservation && <ClientLookupEventsModal
                show={true}
                reservation={reservation}
                hideDesc={true}
                client={client}
                saving={saving}
                handleClose={() => {
                  setShowMoveRegistration(false)
                }}
                handleSave={(d) => {
                  handleMoveReservation(d);
                }}/>
            }


          </MDBox>
        </MDBox>

        <Footer mt={5}/>

      </DashboardLayout>

    </>
  )
}